/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/@babel/runtime/regenerator/index.js":
/*!**********************************************************!*\
  !*** ./node_modules/@babel/runtime/regenerator/index.js ***!
  \**********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(/*! regenerator-runtime */ "./node_modules/regenerator-runtime/runtime.js");


/***/ }),

/***/ "./src/js/bundle/analytics.js":
/*!************************************!*\
  !*** ./src/js/bundle/analytics.js ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BUNDLE_EVENTS": () => (/* reexport safe */ _events_js__WEBPACK_IMPORTED_MODULE_2__.BUNDLE_EVENTS),
/* harmony export */   "normaliseSelections": () => (/* binding */ normaliseSelections),
/* harmony export */   "unlockedTierMinimums": () => (/* binding */ unlockedTierMinimums),
/* harmony export */   "createBundleTracker": () => (/* binding */ createBundleTracker)
/* harmony export */ });
/* harmony import */ var _ids_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ids.js */ "./src/js/bundle/ids.js");
/* harmony import */ var _pricing_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./pricing.js */ "./src/js/bundle/pricing.js");
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./events.js */ "./src/js/bundle/events.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * Shared bundle event tracking. One vocabulary, one payload shape and one emit point for every bundle
 * surface: the steps builder ('pdp-bundle', ./product-bundle-2026.js), the Complete Your Routine modal
 * ('pdp-upsell', templates/product.bundle-modal.liquid), the Build Your Own grid ('byo',
 * ./build-your-own-bundle.js) and the 5 Minute Face routine (./five-minute-face.js, which posts
 * 'pdp-bundle' too - see bundle_surface in basePayload() for why it has to). Sibling of ./pricing.js,
 * which holds what those surfaces share on the cart side. A further bundle surface gets tracking by
 * wiring one tracker, not by reimplementing any of this.
 *
 * WHAT THIS FILE IS NOT FOR
 *
 * Purchase-level reporting doesn't come from here at all, and mustn't be rebuilt here. The builders stamp
 * hidden _bundle_* properties on the cart lines they post; those persist natively to the ORDER line
 * items; the Bundle Engine's Cart Transform renames _bundle_instance to _bundle_group on the line it
 * merges and adds _bundle_discount/_bundle_discount_value/_bundle_pre_discount_total/_bundle_currency;
 * and a Shopify Flow on "Order created" groups the line items by _bundle_group and writes the
 * custom.bundle_state ORDER metafield. Nothing in the theme writes that metafield, and the Cart Transform
 * can't either - a Cart Transform's entire output is lineExpand/lineMerge/lineUpdate, so line attributes
 * are the only thing it can stamp.
 *
 * So this file covers only what never reaches an order: what the shopper did before they bought, and what
 * they did instead of buying. Anything already on an order line item belongs in the order report, not in
 * an event - two sources for one number is how they end up disagreeing.
 *
 * WHY Shopify.analytics.publish AND NOT window.dataLayer
 *
 * Custom pixels run sandboxed in their own iframe: they cannot read window.dataLayer and cannot hear a
 * DOM event dispatched in the main window. The one supported route from theme JS into a pixel is
 * Shopify.analytics.publish(), which every custom and app pixel on the shop can subscribe to and read off
 * event.customData. Publishing therefore keeps GA4 out of the theme entirely: the theme states what
 * happened, the pixel decides what it means and who it goes to.
 *
 * The DOM mirror in emit() is for the main-window tag managers a pixel's sandbox shuts out - Analyzify,
 * Contentsquare and Triple Whale are all app embeds on this shop and all run here rather than in a pixel.
 * Both routes carry the identical payload, so a consumer subscribes on whichever side it lives and
 * nothing has to be emitted twice in two shapes. A consumer that can see both must pick one.
 *
 * NOTHING SENSITIVE GOES IN A PAYLOAD. Published custom events are readable by every pixel on the shop
 * and by anyone with a browser console, so these carry product/variant ids, counts, group ids and money,
 * and no customer data of any kind.
 */

 // Shopify requires a custom event name be namespaced so it can't collide with a standard one. A single
// prefix for the whole shop, so a pixel can match on it rather than listing every event by hand.

var EVENT_NAMESPACE = 'sba'; // The DOM mirror's prefix. Deliberately NOT the same string as the published name: a consumer that can
// see both routes should have to choose, and an identical name is how it ends up wired to both and
// counting everything twice. So 'sba:bundle_added_to_cart' is published and 'theme:bundle_added_to_cart'
// is dispatched, for the one event.

var DOM_EVENT_PREFIX = 'theme:'; // The vocabulary lives in ./events.js so ./cart.js can use it without pulling this file in.

 // toNumericId() stringifies whatever it's handed, so 'undefined' is a real possible output - guard the
// call rather than trying to clean up after it.

var idOrEmpty = function idOrEmpty(value) {
  return value ? (0,_ids_js__WEBPACK_IMPORTED_MODULE_0__.toNumericId)(value) : '';
};
/*
 * The two builders hold a selection in different shapes - the grid's { productId, variantId, variantTitle,
 * price, group, quantity } and the steps builder's { variantGid, productId, shadeLabel, price, group } -
 * and neither is worth reshaping just for this. Both spellings are read here so one payload shape reaches
 * the pixel whichever surface produced it, which is the entire point: a report grouped by bundle_type
 * shouldn't have to know that two builders disagree about what a selection is called.
 */


function normaliseSelections(selections) {
  return (selections || []).map(function (selection) {
    return {
      product_id: idOrEmpty(selection.productId),
      variant_id: idOrEmpty(selection.variantId || selection.variantGid),
      // The chosen shade, where there is one. Named for what it holds rather than 'shade' because the steps
      // builder calls it a shade label and the grid takes it straight off the variant title.
      variant_title: selection.variantTitle || selection.shadeLabel || '',
      // The bundle_config group id, which is also what each line is submitted with as _bundle_step - so a
      // frontend event and an order line item can be grouped by the same category with no lookup between.
      group: selection.group || '',
      quantity: Number(selection.quantity) || 1,
      price_cents: Number(selection.price) || 0
    };
  });
}
/*
 * The tier minimums `itemCount` has reached, ascending. Surfaces detect tier unlocks through this rather
 * than walking config.tiers themselves, so the event can't drift from what the progress bar shows or from
 * what the Bundle Engine actually applies at checkout.
 */

function unlockedTierMinimums(config, itemCount) {
  return (config && config.discountTiers || []).map(function (tier) {
    return parseInt(tier.min_items, 10);
  }).filter(function (minItems) {
    return Number.isFinite(minItems) && itemCount >= minItems;
  }).sort(function (a, b) {
    return a - b;
  });
}
/*
 * Everything every event carries, derived from the surface's live state so no call site has to assemble
 * it and no two of them can assemble it differently.
 *
 * item_count, subtotal_cents and bundle_total_cents come off the SAME discountPercentageFor()/
 * applyDiscount() the kit bag quotes with (./pricing.js), so a tracked value can never disagree
 * with the price the shopper was looking at when they triggered the event.
 */

function basePayload(context) {
  var selections = normaliseSelections(context.selections);
  var itemCount = selections.reduce(function (total, selection) {
    return total + selection.quantity;
  }, 0);
  var subtotal = selections.reduce(function (total, selection) {
    return total + selection.price_cents * selection.quantity;
  }, 0);
  var config = context.config || {};
  return {
    bundle_type: context.bundleType || '',

    /*
     * Which builder the shopper actually used, which bundle_type cannot always answer.
     *
     * bundle_type has to keep matching the _bundle_type posted on the cart line, or a frontend event and
     * an order line item attribute to different things - and that value is not ours to choose. The Bundle
     * Engine validates it against a hardcoded allowlist (VALID_BUNDLE_TYPES = ["pdp-bundle",
     * "pdp-upsell", "byo"] in shared/bundle-rules.js of the functions app) and groupBundleInstances()
     * skips any line whose type is not in it, so a bundle posted under a new name is never priced at all.
     * The 5 Minute Face routine therefore posts 'pdp-bundle', the same as the Bundle PDP steps builder,
     * and the two are indistinguishable on an order.
     *
     * This field is where that distinction lives instead: free of the cart contract, so it can name the
     * surface honestly today. It defaults to bundle_type, so the three surfaces that already have a value
     * of their own carry the same string in both fields and nothing has to special-case them.
     *
     * If the allowlist is ever extended and the Cart Transform, Validation and Discount functions
     * redeployed, bundle_type can take the real value and this field becomes a duplicate worth removing.
     */
    bundle_surface: context.surface || context.bundleType || '',
    bundle_handle: context.handle || '',
    bundle_product_id: idOrEmpty(context.productId),
    parent_variant_id: idOrEmpty(context.parentVariantId),
    // localization.country.iso_code, handed down as data-market-country. On every event without the call
    // sites having to remember, which is the one thing the reporting ticket asks of all of them.
    market: context.market || '',
    // The currency the Storefront request actually resolved in, NOT the shop's default money format -
    // those differ for a shopper in a non-default market. See formatBundleMoney() in
    // ./pricing.js for the same distinction on the display side.
    currency: context.currency || '',
    discount_type: config.discountType || '',
    // What the CURRENT count earns, not the configured ceiling. On a tiered bundle those are different
    // numbers for most of the session, and the ceiling is the one that misleads.
    discount_percentage: (0,_pricing_js__WEBPACK_IMPORTED_MODULE_1__.discountPercentageFor)(config, itemCount),
    min_items: Number.isFinite(context.minItems) ? context.minItems : null,
    // An unset max is Infinity internally so the add CTAs aren't all disabled on first paint, and
    // JSON.stringify turns Infinity into null anyway - made explicit so the payload is the same shape
    // whichever route carries it.
    max_items: Number.isFinite(context.maxItems) ? context.maxItems : null,
    item_count: itemCount,
    // Cents, matching the rest of the theme. NOT converted to major units here: the pixel divides, and
    // doing it in two places is how a rounding difference gets into a revenue figure.
    subtotal_cents: subtotal,
    bundle_total_cents: (0,_pricing_js__WEBPACK_IMPORTED_MODULE_1__.applyDiscount)(config, subtotal, itemCount),
    selections: selections
  };
}

function emit(name, payload) {
  // The published route, and the only one a sandboxed custom pixel can hear.
  try {
    var analytics = window.Shopify && window.Shopify.analytics;

    if (analytics && typeof analytics.publish === 'function') {
      var published = analytics.publish("".concat(EVENT_NAMESPACE, ":").concat(name), payload); // Documented to return a promise in the extension APIs and nothing in particular in the online
      // store one. Only ever caught, never awaited - an analytics call has no business holding up an add
      // to cart, and an unhandled rejection here would surface as a page error.

      if (published && typeof published["catch"] === 'function') published["catch"](function () {});
    }
  } catch (error) {// Consent mode, an ad blocker, or Shopify.analytics simply not up yet on a very fast interaction.
    // None of those are worth a console entry on every event, and none should reach the caller.
  }

  try {
    document.dispatchEvent(new CustomEvent("".concat(DOM_EVENT_PREFIX).concat(name), {
      detail: payload,
      bubbles: true
    }));
  } catch (error) {// As above.
  }
}
/*
 * One tracker per surface instance.
 *
 * `getContext` is called fresh on every event rather than captured once, because the builders mutate
 * their selections array in place - a snapshot taken at construction would report an empty bundle for the
 * rest of the session.
 *
 * `options.once` suppresses repeats. Pass `true` to fire an event at most once per tracker, or a string
 * to scope the dedupe (per tier, per category), which is what keeps a shopper hovering either side of a
 * threshold from firing it a dozen times. reset() clears the record, which a surface calls after a
 * successful add so the NEXT bundle can earn its milestones again rather than looking like it never
 * crossed anything.
 *
 * `options.silent` records an event as having fired without emitting it. It exists for restored state: a
 * kit bag reloaded from a previous session may already sit past a tier or past min_items, and those
 * crossings happened days ago. Emitting them would read as progress the shopper just made; ignoring them
 * would let the session's first trivial change claim a crossing it didn't cause. Marking them spent does
 * neither. Only meaningful alongside `once`.
 */


function createBundleTracker(getContext) {
  var fired = new Set();

  var track = function track(name) {
    var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (options.once) {
      var key = options.once === true ? name : "".concat(name, ":").concat(options.once);
      if (fired.has(key)) return;
      fired.add(key);
    }

    if (options.silent) return;
    var context;

    try {
      context = getContext() || {};
    } catch (error) {
      // Tracking must never be the reason a builder throws mid-render. A dropped event costs a row in a
      // report; an exception here costs the shopper the page.
      return;
    }

    emit(name, _objectSpread(_objectSpread({}, basePayload(context)), detail));
  };

  return {
    track: track,
    reset: function reset() {
      return fired.clear();
    }
  };
}

/***/ }),

/***/ "./src/js/bundle/cart.js":
/*!*******************************!*\
  !*** ./src/js/bundle/cart.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "refreshUpCart": () => (/* binding */ refreshUpCart),
/* harmony export */   "buildComponentLines": () => (/* binding */ buildComponentLines),
/* harmony export */   "refreshThemeCart": () => (/* binding */ refreshThemeCart),
/* harmony export */   "findMissingProperty": () => (/* binding */ findMissingProperty),
/* harmony export */   "submitBundle": () => (/* binding */ submitBundle)
/* harmony export */ });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _limit_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./limit.js */ "./src/js/bundle/limit.js");
/* harmony import */ var _instances_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./instances.js */ "./src/js/bundle/instances.js");
/* harmony import */ var _ids_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./ids.js */ "./src/js/bundle/ids.js");
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./events.js */ "./src/js/bundle/events.js");


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/*
 * The add-to-cart pipeline every bundle surface submits through.
 *
 * Was three copies: the completeness guard, the submit-time limit re-check, the POST, the UpCart refresh
 * and the theme redraw were each written out separately in product-bundle-2026.js,
 * build-your-own-bundle.js and five-minute-face.js. They had already drifted in two ways that mattered,
 * both fixed by there being one of them:
 *
 *   - Only build-your-own-bundle.js called refreshUpCart() and cleared UpCart's open-state mirror, so an
 *     add from the Bundle PDP or the 5 Minute Face routine opened the drawer on a cart UpCart had never
 *     re-read.
 *   - Only product-bundle-2026.js read /cart/add.js's JSON error body, so the other two reported a bare
 *     status where the actual rejection reason was sitting in the response.
 */



 // UpCart is the live cart drawer here (settings.use_upcart), and core.js sets
// upcartShouldSkipAddToCartInterceptor so the theme owns its own add-to-cart. The trade is that UpCart
// only notices an add its interceptor recognises: the theme's ATC posts FormData, but a bundle goes up as
// JSON, which it ignores - so the drawer opens on a cart it never re-read.
//
// upcartRefreshCart() is UpCart's own re-read hook. Awaited, so whatever opens the drawer next is already
// showing the new lines, and typeof-guarded for shops on the theme's own mini-cart.

function refreshUpCart() {
  return _refreshUpCart.apply(this, arguments);
}
/*
 * Builds the /cart/add.js payload: ONE LINE PER COMPONENT, NO PARENT LINE.
 *
 * This is the Bundle Engine's contract for a percentage/tiered_percentage bundle, confirmed with the app
 * 2026-09-04. The older shape posted a parent line carrying _bundle_role: 'parent' and is now refused on
 * both halves - an orphan parent blocks checkout, and components without _bundle_parent fail grouping.
 * A fixed_price bundle does not come through here at all; it submits as an ordinary form post carrying
 * _bundle_selections (see usesComponentLines() in ./config.js).
 *
 * The properties, and who reads them:
 *   _bundle_type      which surface built it. Also the bundle_type on every analytics event, so events
 *                     and order line items attribute to the same surface
 *   _bundle_instance  unique per add, identical across one bundle's lines. The Cart Transform renames it
 *                     to _bundle_group on the merged line, which the Flow groups by to write the
 *                     custom.bundle_state order metafield. Reusing one merges two separate bundles into
 *                     one of double the size, which can cross a tier neither of them earned
 *   _bundle_role      always 'component'
 *   _bundle_parent    the bundle product's own variant id, bare numeric, identical on every line
 *   _bundle_step      the bundle_config group id this line was chosen under
 *
 * `selections` entries may spell the variant id either way - the steps builders hold variantGid, the grid
 * holds variantId - matching normaliseSelections() in ./analytics.js, which reads both for the same
 * reason. Was written out three times, once per surface, differing only in the type value and that
 * spelling.
 */

function _refreshUpCart() {
  _refreshUpCart = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof window.upcartRefreshCart !== 'function')) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            _context.prev = 2;
            _context.next = 5;
            return window.upcartRefreshCart();

          case 5:
            _context.next = 10;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](2);
            // A drawer that fails to refresh must not take the add down with it: the lines are in the cart by
            // this point, and the theme's own cart UI is refreshed separately by the caller.
            console.error('Bundle: UpCart refused to refresh after the add', _context.t0);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 7]]);
  }));
  return _refreshUpCart.apply(this, arguments);
}

function buildComponentLines(_ref) {
  var bundleType = _ref.bundleType,
      parentVariantId = _ref.parentVariantId,
      selections = _ref.selections;
  if (!parentVariantId || !selections || !selections.length) return null;
  var baseProperties = {
    _bundle_type: bundleType,
    _bundle_instance: (0,_instances_js__WEBPACK_IMPORTED_MODULE_2__.generateInstanceId)(),
    _bundle_role: 'component',
    _bundle_parent: (0,_ids_js__WEBPACK_IMPORTED_MODULE_3__.toNumericId)(parentVariantId)
  };
  return selections.map(function (selection) {
    return {
      id: Number((0,_ids_js__WEBPACK_IMPORTED_MODULE_3__.toNumericId)(selection.variantId || selection.variantGid)),
      quantity: selection.quantity || 1,
      properties: _objectSpread(_objectSpread({}, baseProperties), {}, {
        _bundle_step: selection.group
      })
    };
  });
} // Everything the theme needs to redraw after a bundle add, in the order the pieces require.
//
// refreshUpCart() first, because window.cart.redrawCart() below opens the drawer and UpCart has to have
// re-read the cart by then.

function refreshThemeCart() {
  return _refreshThemeCart.apply(this, arguments);
} // Every component line must name both a group and a parent. The engine rejects the WHOLE bundle over
// either being missing - a missing group fails per-group membership, a missing parent fails grouping
// itself - and both land as an unpriced bundle sitting in the cart at full price. Returns the name of the
// first missing property, or null when the payload is complete.

function _refreshThemeCart() {
  _refreshThemeCart = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
    var _document$querySelect;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return refreshUpCart();

          case 2:
            // redrawCart() opens the drawer with a synthetic click on .js-btn-cart, which upCartFunc() treats as a
            // TOGGLE against a js-upcart-open class it keeps as a mirror of the drawer's state. That mirror is only
            // reset by window.upcartOnCartClosed, a callback this version of UpCart no longer fires - so once the
            // shopper has closed the drawer themselves it sticks open, and the next synthetic click reads as
            // "close". Clearing it first leaves the click unambiguous and the mirror correct.
            (_document$querySelect = document.querySelector('.js-btn-upcart-toggle')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.classList.remove('js-upcart-open'); // Drives the theme's own mini-cart markup and header count, which are separate from UpCart's drawer.
            // Same refresh the theme's ordinary add-to-cart does - see triggerAdd() in src/js/cart.js.

            if (window.cart) {
              window.cart.redrawCart();
              window.cart.cartContents();
            }

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _refreshThemeCart.apply(this, arguments);
}

function findMissingProperty(items) {
  var incomplete = (items || []).find(function (item) {
    return !item.properties._bundle_step || !item.properties._bundle_parent;
  });
  if (!incomplete) return null;
  return !incomplete.properties._bundle_step ? '_bundle_step' : '_bundle_parent';
}
/*
 * Submits a built bundle payload.
 *
 * Returns { ok: true, instanceId, data } or { ok: false, reason } where reason is one of:
 *   'incomplete'    the payload is missing _bundle_step or _bundle_parent - nothing was sent
 *   'bundle_limit'  the cart already holds MAX_BUNDLES - nothing was sent
 *   'request_failed' /cart/add.js rejected it, or the request threw
 *
 * The caller keeps its own button state, selection clearing and redraw, because those differ per surface.
 * What is shared is everything between the built payload and the cart being correct afterwards.
 *
 * `limitWatcher` is a createBundleLimitWatcher() handle. Passing it lets a full cart push its freshly
 * counted value back into the watcher, so the CTA's disabled state is corrected by the same request that
 * blocked the add rather than waiting for the next 'cart:updated'.
 *
 * `tracker` is a createBundleTracker() handle. Optional: a surface that is not wired to analytics yet
 * simply omits it and nothing is emitted. ADDED_TO_CART fires BEFORE this returns, so the caller's
 * selections still describe the bundle that went in when the tracker reads its context.
 *
 * `stashForDuplication` records the exact payload against its instance id so the cart's quantity stepper
 * can add a second identical bundle rather than raising the merged line (which the Cart Transform
 * un-merges destructively - see changeBundleQuantity() in src/js/cart.js). Only the steps and upsell
 * surfaces did this before, and hideUnduplicatableBundles() hides the stepper for a bundle with no stash,
 * so turning it on for a surface is a visible change to the cart. Left to the caller for that reason.
 */

function submitBundle(_x) {
  return _submitBundle.apply(this, arguments);
}

function _submitBundle() {
  _submitBundle = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(items) {
    var _ref2,
        limitWatcher,
        tracker,
        _ref2$stashForDuplica,
        stashForDuplication,
        missing,
        instanceId,
        bundleCount,
        response,
        data,
        reason,
        _args3 = arguments;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _ref2 = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {}, limitWatcher = _ref2.limitWatcher, tracker = _ref2.tracker, _ref2$stashForDuplica = _ref2.stashForDuplication, stashForDuplication = _ref2$stashForDuplica === void 0 ? true : _ref2$stashForDuplica;

            if (!(!items || !items.length)) {
              _context3.next = 3;
              break;
            }

            return _context3.abrupt("return", {
              ok: false,
              reason: 'incomplete'
            });

          case 3:
            missing = findMissingProperty(items);

            if (!missing) {
              _context3.next = 7;
              break;
            }

            console.error("Bundle: a selection is missing ".concat(missing, " - not adding to cart"), items);
            return _context3.abrupt("return", {
              ok: false,
              reason: 'incomplete'
            });

          case 7:
            instanceId = items[0].properties._bundle_instance;
            _context3.prev = 8;
            _context3.next = 11;
            return (0,_limit_js__WEBPACK_IMPORTED_MODULE_1__.fetchBundleCount)();

          case 11:
            bundleCount = _context3.sent;

            if (!(bundleCount !== null && bundleCount >= _limit_js__WEBPACK_IMPORTED_MODULE_1__.MAX_BUNDLES)) {
              _context3.next = 16;
              break;
            }

            if (limitWatcher && typeof limitWatcher.apply === 'function') limitWatcher.apply(bundleCount); // A complete bundle the shopper could not add. Invisible in every other report - the order never
            // happens, so there is nothing for the order metafield to describe.

            if (tracker) {
              tracker.track(_events_js__WEBPACK_IMPORTED_MODULE_4__.BUNDLE_EVENTS.ADD_BLOCKED, {
                reason: 'bundle_limit',
                cart_bundle_count: bundleCount,
                max_bundles: _limit_js__WEBPACK_IMPORTED_MODULE_1__.MAX_BUNDLES
              });
            }

            return _context3.abrupt("return", {
              ok: false,
              reason: 'bundle_limit',
              cartBundleCount: bundleCount
            });

          case 16:
            _context3.next = 18;
            return fetch("".concat(window.Shopify.routes.root, "cart/add.js"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items: items
              })
            });

          case 18:
            response = _context3.sent;
            _context3.next = 21;
            return response.json()["catch"](function () {
              return null;
            });

          case 21:
            data = _context3.sent;

            if (response.ok) {
              _context3.next = 25;
              break;
            }

            reason = data && (data.description || data.message) || response.statusText;
            throw new Error("Add to cart failed: ".concat(response.status, " ").concat(reason));

          case 25:
            if (stashForDuplication) (0,_instances_js__WEBPACK_IMPORTED_MODULE_2__.storeBundleItems)(instanceId, items); // instance_id is the join key from this session to the order: it is the _bundle_instance on every
            // component line, which the Cart Transform renames to _bundle_group on the merged line, which the
            // Flow groups by to write custom.bundle_state. Without it these events and the order data can only be
            // compared in aggregate.

            if (tracker) tracker.track(_events_js__WEBPACK_IMPORTED_MODULE_4__.BUNDLE_EVENTS.ADDED_TO_CART, {
              instance_id: instanceId
            });
            _context3.next = 29;
            return refreshThemeCart();

          case 29:
            return _context3.abrupt("return", {
              ok: true,
              instanceId: instanceId,
              data: data
            });

          case 32:
            _context3.prev = 32;
            _context3.t0 = _context3["catch"](8);
            console.error('Bundle: could not add bundle to cart', _context3.t0); // The selection survives a failed add, so this is a bundle the shopper built and still holds.

            if (tracker) tracker.track(_events_js__WEBPACK_IMPORTED_MODULE_4__.BUNDLE_EVENTS.ADD_BLOCKED, {
              reason: 'request_failed'
            });
            return _context3.abrupt("return", {
              ok: false,
              reason: 'request_failed',
              error: _context3.t0
            });

          case 37:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[8, 32]]);
  }));
  return _submitBundle.apply(this, arguments);
}

/***/ }),

/***/ "./src/js/bundle/config.js":
/*!*********************************!*\
  !*** ./src/js/bundle/config.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "parseTiers": () => (/* binding */ parseTiers),
/* harmony export */   "readBundleConfig": () => (/* binding */ readBundleConfig),
/* harmony export */   "usesComponentLines": () => (/* binding */ usesComponentLines)
/* harmony export */ });
/*
 * Reading a bundle's configuration off the host element's data- attributes.
 *
 * Liquid puts the Bundle Engine app metafield (product.metafields.app--378977320961.bundle_config) onto
 * the element as data-discount-type / -percentage / -tiers / -min-items / -max-items / -market-country.
 *
 * Only the pieces every surface reads the same way live here so far. The full reader lands with the
 * steps-engine merge: the rest of that parsing is entangled with each builder's own state, and the two
 * builders disagree on what "no maximum" is (0 in one, Infinity in the other), so unifying it is a
 * behaviour change that belongs with the QA pass for that merge rather than smuggled in here.
 */
// The config's `tiers` array, passed through as escaped JSON. A missing or malformed value degrades to
// "no tiers", which discountPercentageFor() reads as 0%, rather than throwing on first paint.
function parseTiers(raw) {
  if (!raw) return [];

  try {
    var tiers = JSON.parse(raw);
    return Array.isArray(tiers) ? tiers : [];
  } catch (error) {
    return [];
  }
}
/*
 * Returns:
 *   marketCountry      upper-cased ISO code, or '' when unknown. Upper case because the Storefront
 *                      CountryCode enum is, and @inContext rejects a lower-case value.
 *   minItems           0 when unset.
 *   maxItems           Infinity when unset or non-positive, NOT 0. Zero as a sentinel for "no maximum"
 *                      reads as "maximum of nothing" in any `count >= maxItems` test, which disables
 *                      every add CTA on first paint. Infinity is inert in that test and in the steps
 *                      builders' `maxItems > 0 && count > maxItems`, so both spellings behave alike.
 *   discountType       '' when unset.
 *   discountPercentage 0 when unset.
 *   discountTiers      [] when unset or malformed.
 *
 * The last three together are the { discountType, discountPercentage, discountTiers } shape that
 * discountPercentageFor() and applyDiscount() in ./pricing.js take, so the whole object passes straight
 * through.
 */

function readBundleConfig(el) {
  var data = el && el.dataset || {};
  var maxItems = parseInt(data.maxItems, 10);
  return {
    marketCountry: (data.marketCountry || '').toUpperCase(),
    minItems: parseInt(data.minItems, 10) || 0,
    maxItems: Number.isFinite(maxItems) && maxItems > 0 ? maxItems : Infinity,
    discountType: data.discountType || '',
    discountPercentage: parseFloat(data.discountPercentage) || 0,
    discountTiers: parseTiers(data.discountTiers)
  };
} // Which of the Bundle Engine's two cart shapes this bundle takes. Confirmed with the app 2026-09-04:
// it is dictated by discount_type, and getting it wrong means the bundle is not priced at all.
// percentage/tiered_percentage post one line per component with no parent line; fixed_price falls
// through to the theme's ordinary form post carrying _bundle_selections.

function usesComponentLines(config) {
  return config.discountType === 'percentage' || config.discountType === 'tiered_percentage';
}

/***/ }),

/***/ "./src/js/bundle/drawer.js":
/*!*********************************!*\
  !*** ./src/js/bundle/drawer.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "openDrawer": () => (/* binding */ openDrawer),
/* harmony export */   "closeDrawer": () => (/* binding */ closeDrawer),
/* harmony export */   "bindVariantRows": () => (/* binding */ bindVariantRows)
/* harmony export */ });
/*
 * The slide-out dialog choreography, shared by every bundle drawer.
 *
 * Four <dialog> shells are rendered globally from layout/theme.liquid (bundle-modal-dialog,
 * bundle-shade-selector, bundle-product-selector, routine-shade-selector-dialog) and the same open and
 * close sequences were written out at eleven call sites between them, one of which was missing the
 * clearTimeout guard.
 *
 * The transition is Tailwind utilities toggled on the dialog itself, which is why the close is deferred:
 * dialog.close() removes the element from the top layer immediately, so calling it before the transition
 * has run makes the drawer vanish rather than slide out.
 */
// Matches the transition duration on the dialog in src/css/product-bundle-2026.scss. Kept here so the
// two are changed together rather than in whichever call site someone happens to be reading.
var CLOSE_TRANSITION_MS = 300; // Per-dialog pending close, so callers no longer each hold their own timeout handle and a dialog reopened
// mid-close cannot be shut from under the shopper by the previous close landing late.

var pendingCloses = new WeakMap();
function openDrawer(dialog) {
  if (!dialog) return; // Cancel any pending close from a previous interaction first.

  clearTimeout(pendingCloses.get(dialog));
  pendingCloses["delete"](dialog); // showModal() throws on an already-open dialog, which is reachable whenever the shopper reopens before
  // a pending close has run.

  if (!dialog.open) dialog.showModal(); // Next frame, so the element is in the top layer and laid out before the transition starts - toggled in
  // the same frame it opens in, the browser has no "from" state to animate out of and it simply appears.

  requestAnimationFrame(function () {
    dialog.classList.add('lg:!translate-x-0', '!translate-y-0');
  });
}
function closeDrawer(dialog) {
  if (!dialog) return;
  dialog.classList.remove('lg:!translate-x-0', '!translate-y-0');
  clearTimeout(pendingCloses.get(dialog));
  pendingCloses.set(dialog, setTimeout(function () {
    dialog.close();
    pendingCloses["delete"](dialog);
  }, CLOSE_TRANSITION_MS));
}
/*
 * Applies the shared rule for a fetched variant-selector fragment's rows: a sold-out shade stays visible,
 * so the range reads complete, but must not be selectable.
 *
 * `onSelect` is bound only to the rows that are actually pickable. Four copies of this existed with two
 * different strategies - three skipped binding on [data-variant-oos], and five-minute-face.js instead
 * bound everything and un-checked sold-out rows inside its own handler.
 */

function bindVariantRows(container, onSelect) {
  if (!container) return;
  container.querySelectorAll('[data-variant-label]').forEach(function (label) {
    if (label.hasAttribute('data-variant-oos')) {
      label.setAttribute('aria-disabled', 'true');
      return;
    }

    label.addEventListener('click', onSelect);
  });
}

/***/ }),

/***/ "./src/js/bundle/events.js":
/*!*********************************!*\
  !*** ./src/js/bundle/events.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BUNDLE_EVENTS": () => (/* binding */ BUNDLE_EVENTS)
/* harmony export */ });
/*
 * The bundle event vocabulary.
 *
 * Its own module so ./cart.js can name the two events it fires without importing the whole tracker -
 * every surface submits through ./cart.js, and pulling ./analytics.js in behind it put the tracker into
 * bundles that emit nothing.
 *
 * Add a name here rather than passing a string literal at a call site. A report grouped by bundle_type is
 * only possible if an event means the same thing on every surface, and literals at call sites are how
 * that stops being true.
 */

/*
 * The vocabulary. Every surface uses these names and no others - a report grouped by bundle_type is only
 * possible if 'added to cart' means the same event everywhere, and string literals at the call sites are
 * how that stops being true.
 */
var BUNDLE_EVENTS = {
  // The builder is on screen and usable. Deliberately NOT fired on connect: until the Storefront request
  // lands nothing is priced, stocked or addable, so a view counted there isn't a view of a working
  // builder and would quietly flatter every downstream conversion rate.
  VIEWED: 'bundle_viewed',
  // A stored selection was restored from a previous visit. Fired by the three surfaces that persist one:
  // the Build Your Own grid (localStorage, `sba-bundle-${handle}`) and the steps builder and upsell
  // drawer (sessionStorage, keyed per product). Not the 5 Minute Face routine, which persists nothing.
  // Without it a returning shopper lands on a pre-filled builder and inflates every view-to-add rate on
  // the page.
  RESTORED: 'bundle_restored',
  // A merchandising category tab was chosen. Display only - it never touches the selection - but it's the
  // only read on which categories shoppers actually browse.
  GROUP_VIEWED: 'bundle_group_viewed',
  SELECTION_ADDED: 'bundle_selection_added',
  SELECTION_REMOVED: 'bundle_selection_removed',
  // A tiered_percentage threshold was crossed upwards. This is the commercial question the tiers exist to
  // answer: do they pull basket size up, or do shoppers stop at the first one. Fired per tier.
  TIER_UNLOCKED: 'bundle_tier_unlocked',
  // min_items reached for the first time, i.e. the bundle became addable. The denominator for "started a
  // bundle but didn't finish it".
  COMPLETED: 'bundle_completed',
  ADDED_TO_CART: 'bundle_added_to_cart',
  // A bundle the shopper tried to add and couldn't. `reason` names the gate - currently the MAX_BUNDLES
  // cap or a failed cart request. A blocked add is a UX problem that is otherwise completely invisible.
  ADD_BLOCKED: 'bundle_add_blocked',
  // The PDP's Complete Your Routine panel (snippets/bundle-modal-trigger.liquid). Impression and click,
  // which the reporting ticket asks for by name.
  //
  // STILL UNWIRED: declared, but nothing fires either of them. The panel is a Liquid snippet with no
  // component behind it, so unlike the four builders there is no tracker to hang them off - they need an
  // IntersectionObserver for the impression and a click handler for the other. Left declared so whoever
  // does that wires these names rather than inventing two more.
  WIDGET_VIEWED: 'bundle_widget_viewed',
  WIDGET_CLICKED: 'bundle_widget_clicked'
};

/***/ }),

/***/ "./src/js/bundle/fragments.js":
/*!************************************!*\
  !*** ./src/js/bundle/fragments.js ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "productViewUrl": () => (/* binding */ productViewUrl),
/* harmony export */   "fetchFragment": () => (/* binding */ fetchFragment),
/* harmony export */   "renderFragmentInto": () => (/* binding */ renderFragmentInto)
/* harmony export */ });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
 * Fetching a Liquid `?view=` fragment and putting it in the page.
 *
 * Six alternate templates are fetched this way across the bundle surfaces - variant-selector-2026,
 * bundle-short-description-2026, card-short-description-2026, routine-step-card-2026,
 * routine-shade-selector-2026 and bundle-modal - and the same five lines were written out at eight call
 * sites. They exist because the tokenless Storefront API cannot read this shop's metafields: access is
 * not granted on the definitions, so anything metafield-backed has to come from Liquid.
 */

/*
 * Builds a product alternate-template URL.
 *
 * Always through window.Shopify.routes.root, which carries the Markets locale/country subfolder prefix.
 * A bare `/products/...` path drops it and redirects on a localised storefront, which costs a round trip
 * at best and loses the query string at worst. Every call site already did this correctly; routing them
 * all through one builder is what keeps that true.
 */
function productViewUrl(handle, view) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var url = new URL("".concat(window.Shopify.routes.root, "products/").concat(handle), window.location.origin);
  url.searchParams.set('view', view);
  Object.entries(params).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (value !== undefined && value !== null && value !== '') url.searchParams.set(key, value);
  });
  return "".concat(url.pathname).concat(url.search);
} // Returns the fragment's HTML, or null if it could not be fetched. Fails soft by design: every caller
// renders the result into a dialog or a card, and showing error-page content there is worse than showing
// nothing. `label` names the fragment in the console message so a failure is identifiable.

function fetchFragment(_x) {
  return _fetchFragment.apply(this, arguments);
} // Fetch and inject in one step. Returns true when the container was filled, so a caller can decide
// whether to go on and open a dialog around it.

function _fetchFragment() {
  _fetchFragment = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url) {
    var _ref3,
        _ref3$label,
        label,
        response,
        _args = arguments;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref3 = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, _ref3$label = _ref3.label, label = _ref3$label === void 0 ? 'fragment' : _ref3$label;
            _context.prev = 1;
            _context.next = 4;
            return fetch(url);

          case 4:
            response = _context.sent;

            if (response.ok) {
              _context.next = 7;
              break;
            }

            throw new Error("".concat(label, " request failed: ").concat(response.status));

          case 7:
            _context.next = 9;
            return response.text();

          case 9:
            return _context.abrupt("return", _context.sent);

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            console.error("Bundle: could not load ".concat(label), _context.t0);
            return _context.abrupt("return", null);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 12]]);
  }));
  return _fetchFragment.apply(this, arguments);
}

function renderFragmentInto(_x2, _x3) {
  return _renderFragmentInto.apply(this, arguments);
}

function _renderFragmentInto() {
  _renderFragmentInto = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(container, url) {
    var options,
        html,
        _args2 = arguments;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};

            if (container) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", false);

          case 3:
            _context2.next = 5;
            return fetchFragment(url, options);

          case 5:
            html = _context2.sent;

            if (!(html === null)) {
              _context2.next = 8;
              break;
            }

            return _context2.abrupt("return", false);

          case 8:
            container.innerHTML = html;
            return _context2.abrupt("return", true);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _renderFragmentInto.apply(this, arguments);
}

/***/ }),

/***/ "./src/js/bundle/ids.js":
/*!******************************!*\
  !*** ./src/js/bundle/ids.js ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "toNumericId": () => (/* binding */ toNumericId),
/* harmony export */   "toVariantGid": () => (/* binding */ toVariantGid),
/* harmony export */   "toProductGid": () => (/* binding */ toProductGid)
/* harmony export */ });
/*
 * Id coercion at the Shopify boundary.
 *
 * bundle_config (v3) stores bare numeric ids, never GIDs. The Storefront API only speaks GIDs. The DOM
 * carries whichever the Liquid that rendered it chose. So everything inside the module works in bare
 * numeric strings and widens only at the Storefront request.
 */
// Works on both "49110622208228" and "gid://shopify/ProductVariant/49110622208228". String()-coerced
// first, so it is safe on a number as well as a string.
var toNumericId = function toNumericId(id) {
  return String(id).split('/').pop();
};
var toVariantGid = function toVariantGid(numericId) {
  return "gid://shopify/ProductVariant/".concat(numericId);
};
var toProductGid = function toProductGid(numericId) {
  return "gid://shopify/Product/".concat(numericId);
};

/***/ }),

/***/ "./src/js/bundle/instances.js":
/*!************************************!*\
  !*** ./src/js/bundle/instances.js ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "generateInstanceId": () => (/* binding */ generateInstanceId),
/* harmony export */   "newBundleInstanceId": () => (/* binding */ newBundleInstanceId),
/* harmony export */   "storeBundleItems": () => (/* binding */ storeBundleItems),
/* harmony export */   "readBundleItems": () => (/* binding */ readBundleItems)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/*
 * Bundle instance ids, and the stashed add payloads keyed by them.
 *
 * The id half moved from generateInstanceId() in src/js/bundle-storefront.js; the storage half from
 * src/js/bundle-instances.js (SBA-982). They belong together, and merging them removes a duplicate:
 * newBundleInstanceId() there and generateInstanceId() in product-bundle-2026.js were the same function
 * written twice, fallback and all.
 *
 * What the store is for: the cart cannot work out what was in a bundle for itself. Once the Bundle
 * Engine's Cart Transform has merged one, /cart.js reports a SINGLE line - the bundle product's own
 * variant, has_components: true - and the component lines it was built from are not in the payload at
 * all. All that survives of the original add is the instance id, which comes back on the merged line as
 * _bundle_group (confirmed against a live cart 2026-09-24; the theme posts it as _bundle_instance and the
 * function renames it).
 *
 * So the add pipeline stashes its /cart/add.js payload here, keyed by that id, and the cart's quantity
 * stepper reads it back to add a SECOND bundle rather than trying to raise the merged line's quantity -
 * see changeBundleQuantity() in src/js/cart.js for why raising it is not an option.
 *
 * localStorage rather than sessionStorage: a cart outlives a tab, so a bundle added yesterday still needs
 * its payload today. Everything here is best-effort - private browsing and quota errors leave the cart
 * without a payload, which degrades to "this bundle can't be duplicated from the cart", not to an error.
 */
var STORAGE_KEY = 'bundle-builder-instances'; // Bundles per cart are capped at 3, but a shopper can add and remove across a long session and every add
// writes an entry. Oldest-out at this size keeps the store from growing without limit while leaving far
// more history than any live cart can reference.

var MAX_STORED_INSTANCES = 20;

function readStore() {
  try {
    var raw = window.localStorage.getItem(STORAGE_KEY);
    var parsed = raw ? JSON.parse(raw) : null;
    return parsed && _typeof(parsed) === 'object' ? parsed : {};
  } catch (error) {
    return {};
  }
}

function writeStore(store) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch (error) {// Quota or private browsing - nothing to do but carry on without the stash.
  }
} // Groups one add-to-cart's lines together for the Bundle Engine. Must differ on every add: reusing an
// instance id merges two separate bundles into one of double the size, which can cross a tiered threshold
// neither of them earned. Kept well inside the engine's 64-character limit, with no whitespace.
// randomUUID() needs a secure context, which the storefront always is, but the fallback keeps this from
// throwing outright anywhere it is not (a plain-http preview, say).


function generateInstanceId() {
  if (window.crypto && typeof window.crypto.randomUUID === 'function') {
    return "b-".concat(window.crypto.randomUUID());
  }

  return "b-".concat(Date.now().toString(36), "-").concat(Math.random().toString(36).slice(2, 10));
} // src/js/cart.js knows this one by name. Kept as an alias rather than renamed at that call site, which is
// outside the module.

var newBundleInstanceId = generateInstanceId; // `items` is the exact array posted to /cart/add.js - line ids, quantities and properties - so replaying
// it reproduces the bundle exactly, down to the shade picked for each step.

function storeBundleItems(instanceId, items) {
  if (!instanceId || !Array.isArray(items) || !items.length) return;
  var store = readStore();
  store[instanceId] = {
    items: items,
    storedAt: Date.now()
  };
  var ids = Object.keys(store);

  if (ids.length > MAX_STORED_INSTANCES) {
    ids.sort(function (a, b) {
      return (store[a].storedAt || 0) - (store[b].storedAt || 0);
    }).slice(0, ids.length - MAX_STORED_INSTANCES).forEach(function (id) {
      return delete store[id];
    });
  }

  writeStore(store);
}
function readBundleItems(instanceId) {
  if (!instanceId) return null;
  var entry = readStore()[instanceId];
  return entry && Array.isArray(entry.items) && entry.items.length ? entry.items : null;
}

/***/ }),

/***/ "./src/js/bundle/limit.js":
/*!********************************!*\
  !*** ./src/js/bundle/limit.js ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MAX_BUNDLES": () => (/* binding */ MAX_BUNDLES),
/* harmony export */   "countBundles": () => (/* binding */ countBundles),
/* harmony export */   "fetchBundleCount": () => (/* binding */ fetchBundleCount),
/* harmony export */   "createBundleLimitWatcher": () => (/* binding */ createBundleLimitWatcher)
/* harmony export */ });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/*
 * The three-bundle cap: the figure, the counting rules, and the watcher that keeps a surface's CTA in
 * step with the cart.
 *
 * The cap is enforced in four places and they must agree. Three of them now read MAX_BUNDLES from here:
 * this module's watcher (the CTA's disabled state), the submit-time re-check in ./cart.js, and the cart's
 * own quantity steppers via syncBundleLimits() in src/js/cart.js. The fourth is server-side, in
 * snippets/cart-item.liquid, which counts in Liquid so a partial cart redraw cannot wipe the ceiling -
 * that copy still hardcodes 3 and is collapsed in the Liquid phase.
 */
// How many bundles a shopper may hold at once. Every Bundle Engine surface enforces the same figure, so
// it lives here alongside the rest of what the builders share, rather than in any one of them.
var MAX_BUNDLES = 3; // The _bundle_type values the cap applies to - what the builders post on their component lines ('byo' is
// this template's own, see buildCartItems() in build-your-own-bundle.js).

var BUNDLE_TYPES = ['pdp-bundle', 'pdp-upsell', 'byo']; // Counts the bundles in a /cart.js payload. A bundle is in the cart in one of three states and each has
// to count exactly once:
//   - engine-priced: the Cart Transform has merged the components into a single line. That line carries
//     _bundle_discount, which only the function writes, and a real merged line has a non-zero total - a
//     zero one is a leftover, not a bundle.
//   - pending: the components are still separate lines awaiting the merge. They share one
//     _bundle_instance, so the set collapses them to the single bundle they are.
//   - expanded parent: an older/fixed_price-shape line carrying _bundle_type but neither of the above -
//     one line, one bundle.
// Line quantity counts too: a merged bundle line at quantity 2 is two bundles, not one.

function countBundles(cart) {
  var total = 0;
  var pending = new Set();
  var items = cart && cart.items || [];
  items.forEach(function (item) {
    var properties = item.properties || {};

    if (properties._bundle_discount != null && item.final_line_price > 0) {
      total += item.quantity || 1;
      return;
    } // _bundle_group is the merged line's name for _bundle_instance (the function renames it) - accepted
    // here so a bundle whose merged line has no usable total still counts once, not once per line.


    var instance = properties._bundle_instance || properties._bundle_group;

    if (instance) {
      pending.add(instance);
      return;
    }

    if (BUNDLE_TYPES.includes(properties._bundle_type)) {
      total += item.quantity || 1;
    }
  });
  return total + pending.size;
} // Null means "couldn't tell", not "none". A cart that can't be read is not a cart that's provably full,
// so callers let the add through - Shopify and the Bundle Engine's own validation still have the final
// say. Failing closed here would block every add on one flaky request.

function fetchBundleCount() {
  return _fetchBundleCount.apply(this, arguments);
}
/*
 * Keeps a surface's "cart is full" flag current.
 *
 * Was three near-identical copies of initBundleLimit/refreshBundleLimit/applyBundleCount, one per
 * builder, differing only in which redraw they called at the end.
 *
 * Seeded once on connect, then kept current off cart.js's own 'cart:updated' event. That event is
 * dispatched with two different payloads: the full cart object from cartSummary(), and a count-only
 * fallback from the remove path which says nothing about bundles - so the latter triggers a re-read
 * rather than being miscounted from.
 *
 * Note UpCart renders the slide-out itself and dispatches nothing, so removing a bundle there leaves the
 * flag stale until the next theme-side cart change. The submit-time re-check in ./cart.js is what keeps
 * that from mattering.
 *
 * `onChange(reached)` fires only when the flag actually flips, so a caller can redraw unconditionally.
 * Returns a handle carrying the current flag, a manual refresh, and a destroy() for disconnectedCallback.
 */

function _fetchBundleCount() {
  _fetchBundleCount = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
    var response;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return fetch("".concat(window.Shopify.routes.root, "cart.js"), {
              cache: 'no-store'
            });

          case 3:
            response = _context2.sent;

            if (response.ok) {
              _context2.next = 6;
              break;
            }

            return _context2.abrupt("return", null);

          case 6:
            _context2.t0 = countBundles;
            _context2.next = 9;
            return response.json();

          case 9:
            _context2.t1 = _context2.sent;
            return _context2.abrupt("return", (0, _context2.t0)(_context2.t1));

          case 13:
            _context2.prev = 13;
            _context2.t2 = _context2["catch"](0);
            console.error('Bundle: could not read the cart to check the bundle limit', _context2.t2);
            return _context2.abrupt("return", null);

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 13]]);
  }));
  return _fetchBundleCount.apply(this, arguments);
}

function createBundleLimitWatcher() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      onChange = _ref.onChange;

  var watcher = {
    reached: false,
    refresh: refresh,
    destroy: destroy
  };

  function apply(count) {
    var reached = count >= MAX_BUNDLES;
    if (reached === watcher.reached) return;
    watcher.reached = reached;
    if (typeof onChange === 'function') onChange(reached);
  }

  function refresh() {
    return _refresh.apply(this, arguments);
  }

  function _refresh() {
    _refresh = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var count;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetchBundleCount();

            case 2:
              count = _context.sent;

              if (!(count === null)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              apply(count);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _refresh.apply(this, arguments);
  }

  function onCartUpdated(event) {
    var cart = event.detail;

    if (cart && cart.items) {
      apply(countBundles(cart));
    } else {
      refresh();
    }
  }

  function destroy() {
    document.removeEventListener('cart:updated', onCartUpdated);
  }

  document.addEventListener('cart:updated', onCartUpdated);
  refresh(); // Exposed so the submit-time re-check in ./cart.js can push a freshly counted cart back in without
  // a second request.

  watcher.apply = apply;
  return watcher;
}

/***/ }),

/***/ "./src/js/bundle/pricing.js":
/*!**********************************!*\
  !*** ./src/js/bundle/pricing.js ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "toCents": () => (/* binding */ toCents),
/* harmony export */   "formatBundleMoney": () => (/* binding */ formatBundleMoney),
/* harmony export */   "maxSellablePrice": () => (/* binding */ maxSellablePrice),
/* harmony export */   "discountPercentageFor": () => (/* binding */ discountPercentageFor),
/* harmony export */   "applyDiscount": () => (/* binding */ applyDiscount),
/* harmony export */   "bundleDisplayPrice": () => (/* binding */ bundleDisplayPrice)
/* harmony export */ });
/* harmony import */ var _formatMoney_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../formatMoney.js */ "./src/js/formatMoney.js");
/* harmony import */ var _config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./config.js */ "./src/js/bundle/config.js");
/*
 * Every money figure a bundle surface displays. One implementation, because four disagreeing ones is
 * how a product card and its own PDP came to quote different savings for the same bundle.
 */

 // Storefront prices arrive as decimal strings ("24.00"). Cents are the unit throughout the module:
// bundle-analytics.js publishes cents, the discount maths rounds in cents, and converting in more than
// one place is how a rounding difference gets into a revenue figure.

function toCents(amount) {
  var value = parseFloat(amount);
  return Number.isFinite(value) ? Math.round(value * 100) : undefined;
} // Formats a price in the currency the Storefront request actually resolved (`currencyCode`) rather than
// the shop's static window.theme.moneyFormat, which is set once at page load from shop.money_format (see
// javascript-lang.liquid) and reflects only the shop's default market - so it can carry the wrong symbol
// for a shopper browsing in another one. Falls back to that static format when no currency has come back
// yet (nothing fetched, or the request failed) or the code is not one Intl recognises.
//
// `trimTrailingZeros` reproduces Liquid's money_without_trailing_zeros, for callers rendering alongside
// server-rendered prices that use it (product cards). Off by default.

function formatBundleMoney(cents, currencyCode) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$trimTrailingZero = _ref.trimTrailingZeros,
      trimTrailingZeros = _ref$trimTrailingZero === void 0 ? false : _ref$trimTrailingZero;

  if (currencyCode) {
    try {
      var fractionDigits = trimTrailingZeros && cents % 100 === 0 ? 0 : 2;
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
      }).format(cents / 100);
    } catch (error) {// Fall through to the static format below.
    }
  }

  return (0,_formatMoney_js__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(cents, window.theme && window.theme.moneyFormat);
}
/*
 * The "bought separately" ceiling: the dearest price a set of variants could contribute to the
 * compare-at figure a saving is quoted against.
 *
 * SOLD-OUT VARIANTS ARE EXCLUDED. Agreed 2026-09-30, and it is a change for the steps builder, which
 * previously counted every variant regardless.
 *
 * Before this, the two implementations disagreed: maxVariantPrice() in product-bundle-2026.js counted
 * sold-out variants, getProductMaxPriceCents() in bundle-card-price.js did not, so a PDP and its own
 * product card quoted different savings for the same bundle. (The comment in the former asserting that
 * the card "likewise doesn't filter" had gone stale - the card was changed in the opposite direction on
 * SBA-982 and the comment was not updated.)
 *
 * Excluding is the defensible side of that: availableForSale is false both for a genuinely out-of-stock
 * variant and for one excluded from the buyer's market catalog, and in neither case can the shopper
 * actually buy it, so quoting a saving against it overstates the offer.
 *
 * Known consequence, which the old steps-builder comment recorded as an EU regression: where the dearest
 * variant is unavailable in a given market, the ceiling now falls to the dearest one that IS available,
 * so the displayed saving is smaller in that market than in one where the dearest is sellable. That is
 * the honest figure rather than a bug, but it does mean the same bundle can advertise different savings
 * market to market. Flagged for UAT.
 *
 * `entries` is [{ cents, available }] - each surface normalises its own variant shape into this.
 * Returns undefined when nothing resolved a price at all, so a caller can keep its server-rendered seed
 * rather than render a zero.
 */

function maxSellablePrice(entries) {
  var resolved = (entries || []).filter(function (entry) {
    return entry && Number.isFinite(entry.cents);
  });
  if (!resolved.length) return undefined;
  var sellable = resolved.filter(function (entry) {
    return entry.available !== false;
  }); // Nothing sellable is not the same as nothing priced. getProductMaxPriceCents() used to return 0 here,
  // which makes the compare-at price zero and the saving negative - worse than the overstatement this
  // rule exists to avoid. A fully sold-out step still has a real "bought separately" worth, so fall back
  // to the dearest resolved price. The step is unpurchasable anyway and the builder blocks the add.

  var pool = sellable.length ? sellable : resolved;
  return pool.reduce(function (max, entry) {
    return max === undefined || entry.cents > max ? entry.cents : max;
  }, undefined);
} // The percentage off `itemCount` selections earns under a bundle's config: a flat rate for "percentage",
// or the highest tier the count reaches for "tiered_percentage" (tiers are not guaranteed to arrive
// sorted, so this takes the best match rather than the last). Anything else, including a config with no
// discount set, is 0% rather than guessed at.
//
// `config` is { discountType, discountPercentage, discountTiers } - see readBundleConfig() in ./config.js.

function discountPercentageFor(config, itemCount) {
  if (!config) return 0;
  if (config.discountType === 'percentage') return config.discountPercentage || 0;

  if (config.discountType === 'tiered_percentage') {
    var tiers = config.discountTiers || [];
    return tiers.reduce(function (best, tier) {
      var minItems = parseInt(tier.min_items, 10);
      var percentage = parseFloat(tier.percentage);
      if (!Number.isFinite(minItems) || !Number.isFinite(percentage)) return best;
      if (itemCount < minItems) return best;
      return Math.max(best, percentage);
    }, 0);
  }

  return 0;
} // What `total` worth of components actually costs as a bundle, in cents. Display only - the real discount
// is applied at checkout by the Bundle Engine function, which this mirrors.

function applyDiscount(config, total, itemCount) {
  var percentage = discountPercentageFor(config, itemCount);
  if (!percentage) return total;
  return Math.round(total * (1 - percentage / 100));
}
/*
 * What a bundle actually costs the shopper, in cents - the figure that belongs in the price slot, with
 * `total` (the components bought separately) belonging in the struck-through one beside it.
 *
 * The two bundle shapes reach that figure from opposite ends, and conflating them is the bug this
 * exists to close:
 *   percentage / tiered_percentage - no parent cart line exists, so the price IS the discounted
 *                                    component sum and `fixedPrice` is meaningless (the bundle
 *                                    product's Admin price is 0 for these by convention anyway).
 *   fixed_price                    - ONE parent line, whose own Markets-resolved price is the whole
 *                                    bundle total; the components ride along inside it at no cost of
 *                                    their own. applyDiscount() returns `total` untouched here, because
 *                                    discountPercentageFor() knows no percentage for this type - so a
 *                                    surface that just displays its return value quotes the component
 *                                    sum as the price, shows no saving at all, and never mentions the
 *                                    price the shopper is actually charged.
 *
 * `fixedPrice` is the parent variant's price in cents, which Liquid stamps on the host element as
 * data-fixed-price (already Markets-resolved, so it is directly comparable with the @inContext
 * component prices `total` is built from). A missing or zero one falls back to the discounted total
 * rather than rendering a confident 0.00 - a bundle product with no price set is a merchandising
 * error, and the component sum is the least wrong thing to show while it stands.
 */

function bundleDisplayPrice(config, total, itemCount, fixedPrice) {
  var discounted = applyDiscount(config, total, itemCount);
  if ((0,_config_js__WEBPACK_IMPORTED_MODULE_1__.usesComponentLines)(config)) return discounted;
  return Number.isFinite(fixedPrice) && fixedPrice > 0 ? fixedPrice : discounted;
}

/***/ }),

/***/ "./src/js/bundle/storefront.js":
/*!*************************************!*\
  !*** ./src/js/bundle/storefront.js ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "STOREFRONT_API_VERSION": () => (/* binding */ STOREFRONT_API_VERSION),
/* harmony export */   "BUNDLE_NODE_FIELDS": () => (/* binding */ BUNDLE_NODE_FIELDS),
/* harmony export */   "GRID_NODE_FIELDS": () => (/* binding */ GRID_NODE_FIELDS),
/* harmony export */   "VARIANT_PRICE_FIELDS": () => (/* binding */ VARIANT_PRICE_FIELDS),
/* harmony export */   "fetchBundleNodes": () => (/* binding */ fetchBundleNodes)
/* harmony export */ });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/*
 * The tokenless Storefront API client every bundle surface resolves its product data through.
 *
 * Moved from src/js/bundle-storefront.js (SBA-985), which itself came out of product-bundle-2026.js
 * (SBA-979). SBA-1041's src/js/bundle-shared.js was a second, earlier fork of the same code; it has been
 * deleted in favour of this, which is a strict superset of it.
 */
// Keep in sync with whatever Storefront API version the project targets elsewhere - confirmed 2026-08-21
// that this version needs no access token for Product/ProductVariant fields (tokenless access).
var STOREFRONT_API_VERSION = '2026-07'; // The field set the steps builder needs: enough to fill in a step row's image, title, price and OOS
// state. The grid builder asks for more (see GRID_NODE_FIELDS below) because its cards render a whole
// product tile plus an inline shade picker.

var BUNDLE_NODE_FIELDS = "\n  __typename\n  ... on Product {\n    id\n    title\n    handle\n    featuredImage {\n      url\n      altText\n    }\n  }\n  ... on ProductVariant {\n    id\n    title\n    price {\n      amount\n      currencyCode\n    }\n    availableForSale\n  }\n"; // SBA-985. The grid builder resolves a whole card from one request rather than the steps builder's
// image/title/price, so it also takes:
//   availableForSale  - whether ANY variant is in stock, which is what sinks a card to the base of its
//                       group in the suppressed/waitlist state.
//   priceRange        - the "from" price shown on a card before a shade is picked. compareAtPriceRange
//                       drives the struck-through price on the card.
//   tags              - the card's "MADE IN KOREA"/"NEW" badge, which product-card-2026 derives from a
//                       product's `card-tag-*` tags.
//   variants(100)     - so a card's shade picker can be built and priced without a second request.
//                       100 is the API's per-page ceiling and comfortably above the largest real shade
//                       range on this shop (42 across the whole test bundle).
// Deliberately NOT asked for: metafields. Storefront access isn't granted on this shop's metafield
// definitions (that's why the steps builder fetches short descriptions from [handle].js separately),
// and an inaccessible field would surface as a GraphQL error on every request.

var GRID_NODE_FIELDS = "\n  __typename\n  ... on Product {\n    id\n    title\n    handle\n    tags\n    availableForSale\n    featuredImage {\n      url\n      altText\n    }\n    priceRange {\n      minVariantPrice { amount currencyCode }\n    }\n    compareAtPriceRange {\n      minVariantPrice { amount currencyCode }\n    }\n    variants(first: 100) {\n      nodes {\n        id\n        title\n        availableForSale\n        price { amount currencyCode }\n        image { url altText }\n      }\n    }\n  }\n  ... on ProductVariant {\n    id\n    title\n    price {\n      amount\n      currencyCode\n    }\n    availableForSale\n  }\n"; // The leanest set: just enough to price a variant and know whether it can be bought. Used by the product
// card, which resolves only prices and never renders a product's own title or image from the response.

var VARIANT_PRICE_FIELDS = "\n  ... on ProductVariant {\n    id\n    availableForSale\n    price {\n      amount\n      currencyCode\n    }\n  }\n";

var nodesQuery = function nodesQuery(fields) {
  return "\n  query BundleProducts($ids: [ID!]!) {\n    nodes(ids: $ids) {\n      ".concat(fields, "\n    }\n  }\n");
}; // Used whenever the buyer's active Markets country is known (data-market-country on the builder element,
// sourced from Liquid's localization.country.iso_code). Without @inContext, the tokenless request always
// resolves price.amount in the shop's default market/currency regardless of which one the buyer is
// actually browsing in - which is how a shopper in a EUR market could see a EUR amount rendered with the
// shop's default GBP symbol (formatBundleMoney() below covers the symbol side; this covers the amount).


var nodesQueryInContext = function nodesQueryInContext(fields) {
  return "\n  query BundleProducts($ids: [ID!]!, $country: CountryCode!) @inContext(country: $country) {\n    nodes(ids: $ids) {\n      ".concat(fields, "\n    }\n  }\n");
}; // One tokenless Storefront request for a batch of Product/ProductVariant GIDs.
//
// `country` is the buyer's active Markets country (may be blank, in which case the request falls back to
// the shop's default market). `fields` is the inline fragment set to select - BUNDLE_NODE_FIELDS or
// GRID_NODE_FIELDS above.


function fetchBundleNodes(_x) {
  return _fetchBundleNodes.apply(this, arguments);
}

function _fetchBundleNodes() {
  _fetchBundleNodes = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(ids) {
    var _ref,
        country,
        _ref$fields,
        fields,
        useContext,
        response,
        _yield$response$json,
        data,
        errors,
        _args = arguments;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, country = _ref.country, _ref$fields = _ref.fields, fields = _ref$fields === void 0 ? BUNDLE_NODE_FIELDS : _ref$fields;
            useContext = Boolean(country);
            _context.next = 4;
            return fetch("/api/".concat(STOREFRONT_API_VERSION, "/graphql.json"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                query: useContext ? nodesQueryInContext(fields) : nodesQuery(fields),
                variables: useContext ? {
                  ids: ids,
                  country: country
                } : {
                  ids: ids
                }
              })
            });

          case 4:
            response = _context.sent;

            if (response.ok) {
              _context.next = 7;
              break;
            }

            throw new Error("Storefront API request failed: ".concat(response.status));

          case 7:
            _context.next = 9;
            return response.json();

          case 9:
            _yield$response$json = _context.sent;
            data = _yield$response$json.data;
            errors = _yield$response$json.errors;

            // A single inaccessible field (e.g. a metafield without Storefront API access granted on its
            // definition) surfaces as a GraphQL error alongside otherwise-usable `data` - only throw (and so abort
            // every card's image/price) when there's no data to fall back on. Log the rest so a real access/config
            // problem is still visible in the console rather than silently swallowed.
            if (errors && errors.length) {
              console.error('Bundle: Storefront API returned errors', errors);
            }

            if (!(!data && errors && errors.length)) {
              _context.next = 15;
              break;
            }

            throw new Error(errors[0].message);

          case 15:
            return _context.abrupt("return", data && data.nodes || []);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchBundleNodes.apply(this, arguments);
}

/***/ }),

/***/ "./src/js/formatMoney.js":
/*!*******************************!*\
  !*** ./src/js/formatMoney.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "formatMoney": () => (/* binding */ formatMoney)
/* harmony export */ });
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
function formatMoney(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }

  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || "${{amount}}";

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;

    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}
;

/***/ }),

/***/ "./node_modules/regenerator-runtime/runtime.js":
/*!*****************************************************!*\
  !*** ./node_modules/regenerator-runtime/runtime.js ***!
  \*****************************************************/
/***/ ((module) => {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : 0
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!***************************************!*\
  !*** ./src/js/product-bundle-2026.js ***!
  \***************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./bundle/ids.js */ "./src/js/bundle/ids.js");
/* harmony import */ var _bundle_storefront_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./bundle/storefront.js */ "./src/js/bundle/storefront.js");
/* harmony import */ var _bundle_pricing_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./bundle/pricing.js */ "./src/js/bundle/pricing.js");
/* harmony import */ var _bundle_config_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./bundle/config.js */ "./src/js/bundle/config.js");
/* harmony import */ var _bundle_limit_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./bundle/limit.js */ "./src/js/bundle/limit.js");
/* harmony import */ var _bundle_cart_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./bundle/cart.js */ "./src/js/bundle/cart.js");
/* harmony import */ var _bundle_analytics_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./bundle/analytics.js */ "./src/js/bundle/analytics.js");
/* harmony import */ var _bundle_fragments_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./bundle/fragments.js */ "./src/js/bundle/fragments.js");
/* harmony import */ var _bundle_drawer_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./bundle/drawer.js */ "./src/js/bundle/drawer.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*
 * Bundle PDP steps builder ('pdp-bundle') and the Complete Your Routine upsell drawer ('pdp-upsell').
 *
 * The id coercion, the tokenless Storefront request and its field sets, money formatting, the Bundle
 * Engine discount maths, the "bought separately" ceiling rule, the three-bundle cap, the add-to-cart
 * pipeline, the `?view=` fragment fetch and the drawer choreography all live in ./bundle/. This file
 * owns the steps layout and its selection state, and nothing else.
 *
 * The wrapper methods below (formatBundleMoney, discountPercentageFor, applyDiscount, fetchBundleNodes)
 * are kept as methods rather than replaced with direct calls at every site because BundleModalBuilder,
 * further down, inherits them and feeds them its own per-instance state. That inheritance is unpicked in
 * the steps-engine phase; until then the wrappers are what hold it together.
 */










var BundleBuilder = /*#__PURE__*/function (_HTMLElement) {
  _inherits(BundleBuilder, _HTMLElement);

  var _super = _createSuper(BundleBuilder);

  function BundleBuilder() {
    _classCallCheck(this, BundleBuilder);

    return _super.apply(this, arguments);
  }

  _createClass(BundleBuilder, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;

      this.initBundleContext({
        heroRoot: this.closest('[data-product-main]')
      });
      this.fields = Array.from(this.querySelectorAll('[data-bundle-option-input]'));
      this.stepEls = Array.from(this.querySelectorAll('[data-bundle-step]')); // The price row, saving badge and compare-at price live in the section header, above
      // <bundle-builder> - not inside it - so they're resolved relative to the section wrapper rather
      // than via this.querySelector().
      // Selections persist across a refresh via sessionStorage, keyed by product (not the section/form id,
      // which is shared by every product using this template) - restored before the first updateState() so
      // the initial render already reflects them, then kept in sync on every change.

      this.storageKey = "bundle-builder-selections:".concat(this.dataset.productId);
      this.restoreSelections();
      this.addEventListener('change', function (event) {
        if (!event.target.matches('[data-bundle-option-input]')) return;
        var stepEl = event.target.closest('[data-bundle-step]');

        _this.updateOptionTitle(event.target);

        _this.updateStepImage(stepEl);

        _this.updateState(); // A <select> step (multiple distinct products) can itself contain a multi-variant product (see
        // data-variant-count in product-bundle-2026-step.liquid) - picking one opens the same shade dialog the single-product picker uses, rather than silently
        // committing to that product's first variant. updateState() above already treats this field as
        // "incomplete" until a shade override lands (see its per-field handling), so the ATC button stays
        // disabled while the dialog is open.


        if (event.target.tagName === 'SELECT') {
          var option = event.target.selectedOptions[0];
          var variantCount = option ? parseInt(option.dataset.variantCount || '1', 10) : 1;

          if (option && option.value && variantCount > 1) {
            _this.openSelectShadeDialog(stepEl, option);
          }
        }
      });
      this.initShadeTriggers();
      this.initProductTriggers();
      this.initCartSubmission();
      this.initBundleLimit();
      this.updateState();
      this.resolveProductData();
    } // Which of the two cart shapes the Bundle Engine expects for this bundle, confirmed 2026-09-04. The
    // shape is dictated by discount_type and getting it wrong means the bundle isn't priced at all - the
    // lines sit at full price and checkout is blocked - so this branches on the config rather than
    // sending one shape for everything:
    //   fixed_price  - a single parent line carrying _bundle_selections, exactly as before. Left to the
    //                  theme's normal form post (triggerAdd() in cart.js), which is what the {% form %}
    //                  and its hidden inputs in bundle-builder-2026.liquid already do.
    //   percentage / tiered_percentage - one line per component and NO parent line, all in a single
    //                  /cart/add.js call, with no _bundle_selections anywhere. That can't be expressed as
    //                  a form post, so the submit is intercepted here and posted as JSON instead.
    //                  The parent line was removed by the app's split-logic change - see
    //                  buildCartItems() for why, and for why sending it now breaks the bundle.
    // An unrecognised/absent discount_type falls through to the form post: the old shape is the safer
    // default, since it's what every existing bundle already used.

    /*
     * The state both builders need before anything else runs.
     *
     * BundleModalBuilder deliberately does NOT call super.connectedCallback() - it shares this class's
     * cart contract and pricing but almost none of its DOM - so this is the one place that shared state is
     * set. It used to be sixteen identical lines written out in each connectedCallback, and every bug that
     * came of them drifting apart was the same bug twice: maxItemCount() threw because this.fields did not
     * exist on the subclass, and the drawer reported GB-only stock as available everywhere because
     * marketCountry and currencyCode were never set on it.
     *
     * `heroRoot` is the only genuine difference. The standalone builder's hero price lives outside the
     * element, up in the PDP's [data-product-main]; the drawer renders its own inside itself.
     */

  }, {
    key: "initBundleContext",
    value: function initBundleContext(_ref) {
      var _this2 = this;

      var heroRoot = _ref.heroRoot;
      this.selectionsInput = this.querySelector('[data-bundle-selections-input]');
      this.variantIdInput = this.querySelector('input[name="id"]');
      this.compareAtInput = this.querySelector('[data-bundle-compare-at-input]');
      this.atcButton = this.querySelector('[data-atc-button]');
      this.ctaLabelEl = this.querySelector('[data-bundle-cta-label]');
      var config = (0,_bundle_config_js__WEBPACK_IMPORTED_MODULE_4__.readBundleConfig)(this);
      this.minItems = config.minItems;
      this.maxItems = config.maxItems;
      this.marketCountry = config.marketCountry;
      this.discountType = config.discountType;
      this.discountPercentage = config.discountPercentage;
      this.discountTiers = config.discountTiers; // Set by resolveProductData() from whatever currency the Storefront request actually resolved in.

      this.currencyCode = '';
      this.productsById = new Map();
      this.variantsById = new Map(); // The bundle product's own variant price, Markets-resolved by Liquid (data-fixed-price, see
      // bundle-builder-2026.liquid). For a fixed_price bundle this IS what the shopper is charged - the
      // single parent line's cost - so updateHeroSaving() displays it rather than the component sum. It is
      // 0 for a percentage/tiered_percentage bundle by convention, and unused there in any case.
      // Previously set by BundleModalBuilder alone, where nothing ever read it, and not set at all on the
      // standalone builder - so `this.fixedPrice` was undefined in the base class's own pricing method.

      this.fixedPrice = parseInt(this.dataset.fixedPrice || '0', 10);
      /*
       * Both classes get a tracker here for the same reason everything else shared lives here: the drawer
       * does not call super.connectedCallback(), so this is the only place that runs for both.
       *
       * Built before anything that can fire an event, and reading its context lazily - the builders replace
       * this.selections wholesale on every updateState(), so a context captured now would report an empty
       * bundle for the rest of the session.
       */

      this.tracker = (0,_bundle_analytics_js__WEBPACK_IMPORTED_MODULE_7__.createBundleTracker)(function () {
        return _this2.trackerContext();
      }); // Nothing is tracked until the Storefront request lands - see startTracking(). Until then the
      // builder is not priced, stocked or addable, and a selection restored from sessionStorage is not a
      // choice the shopper just made.

      this.trackingReady = false;
      this.trackedSelections = new Map();
      this.heroPriceEl = heroRoot && heroRoot.querySelector('[data-bundle-hero-price]');
      this.heroSavingEl = heroRoot && heroRoot.querySelector('[data-bundle-hero-saving]');
      this.heroSavingAmountEl = this.heroSavingEl && this.heroSavingEl.querySelector('[data-bundle-hero-saving-amount]');
      this.heroCompareAtPriceEl = heroRoot && heroRoot.querySelector('[data-bundle-hero-compare-at-price]');
    }
    /* ------------------------------------------------------------- analytics */

    /*
     * The context every event's payload is built from (basePayload() in ./bundle/analytics.js). Inherited
     * by BundleModalBuilder unchanged: everything it reads is either shared state set in
     * initBundleContext() or already per-surface, bundleTypeFromForm() included.
     */

  }, {
    key: "trackerContext",
    value: function trackerContext() {
      return {
        // Matches the _bundle_type this surface stamps on its cart lines (see buildCartItems()), so an
        // event and an order line item attribute to the same thing. Read from the form rather than
        // hardcoded, which is what makes the drawer report 'pdp-upsell' without overriding this.
        bundleType: this.bundleTypeFromForm(),
        handle: this.dataset.handle || '',
        productId: this.dataset.productId,
        parentVariantId: this.variantIdInput && this.variantIdInput.value,
        market: this.marketCountry,
        currency: this.currencyCode,
        config: this.discountConfig(),
        minItems: this.minItems,
        maxItems: this.maxItems,
        selections: this.selections
      };
    }
    /*
     * Opens tracking once the Storefront request has landed, which both resolveProductData()
     * implementations call at their end.
     *
     * Deliberately not in connectedCallback(): until this point nothing is priced, stocked or addable, so
     * a view counted there would be a view of a builder the shopper could not use, and the selection
     * restored from sessionStorage before it is not something they just chose. The trade is that a failed
     * Storefront request produces no view at all, which is the correct reading of it - there was no usable
     * builder to view. Same bargain the Build Your Own grid strikes.
     */

  }, {
    key: "startTracking",
    value: function startTracking() {
      this.tracker.track(_bundle_analytics_js__WEBPACK_IMPORTED_MODULE_7__.BUNDLE_EVENTS.VIEWED, {}, {
        once: true
      });
      var restored = (this.selections || []).length;

      if (restored) {
        this.tracker.track(_bundle_analytics_js__WEBPACK_IMPORTED_MODULE_7__.BUNDLE_EVENTS.RESTORED, {
          restored_item_count: restored
        }, {
          once: true
        }); // A restored selection can already sit past a tier or past min_items, but those crossings happened
        // in an earlier visit. Marked spent rather than emitted, so the restore doesn't read as progress
        // the shopper just made and the session's first real crossing is still a genuine one.

        this.trackMilestones({
          silent: true
        });
      } // Seeded from whatever survived the restore and the availability pass, so neither reads as the
      // shopper adding anything. Everything after this point is theirs.


      this.seedTrackedSelections();
      this.trackingReady = true;
    }
    /*
     * Emits what changed since the last updateState().
     *
     * Diffed here rather than fired from each mutator because there are too many ways a selection can
     * change - a <select>, the product drawer, the shade dialog, a step going out of stock - and a per-mutator event would miss some and double-count others. updateState() is the
     * one funnel they all pass through.
     *
     * Keyed by group AND variant, not by group alone: the upsell drawer lets a group hold up to its own
     * `max` picks, and keying by group would collapse those to one. A changed shade falls out as a remove
     * plus an add, which is what it is - a different variant in the same step.
     */

  }, {
    key: "trackSelectionDelta",
    value: function trackSelectionDelta() {
      var _this3 = this;

      if (!this.trackingReady) return;
      var current = this.selectionsByKey();
      var previous = this.trackedSelections;
      previous.forEach(function (entry, key) {
        if (current.has(key)) return;

        _this3.tracker.track(_bundle_analytics_js__WEBPACK_IMPORTED_MODULE_7__.BUNDLE_EVENTS.SELECTION_REMOVED, {
          item: (0,_bundle_analytics_js__WEBPACK_IMPORTED_MODULE_7__.normaliseSelections)([entry])[0],
          quantity_delta: -1
        });
      });
      current.forEach(function (entry, key) {
        if (previous.has(key)) return;

        _this3.tracker.track(_bundle_analytics_js__WEBPACK_IMPORTED_MODULE_7__.BUNDLE_EVENTS.SELECTION_ADDED, {
          item: (0,_bundle_analytics_js__WEBPACK_IMPORTED_MODULE_7__.normaliseSelections)([entry])[0],
          quantity_delta: 1
        });
      });
      this.trackedSelections = current;
    } // Each live selection against the key the diff above compares on. The entry itself is the value, so a
    // removal can still describe what left rather than only naming it.

  }, {
    key: "selectionsByKey",
    value: function selectionsByKey() {
      return new Map((this.selections || []).map(function (entry) {
        return ["".concat(entry.group, "|").concat(entry.variantGid), entry];
      }));
    }
  }, {
    key: "seedTrackedSelections",
    value: function seedTrackedSelections() {
      this.trackedSelections = this.selectionsByKey();
    }
    /*
     * Threshold crossings, fired from updateState() rather than from each mutator so a crossing is caught
     * once however the count got there.
     *
     * Both are deduped - a shopper changing their mind either side of a tier would otherwise fire it
     * repeatedly, and a selection that drops below min_items and back has not "completed" twice. The record
     * is cleared after a successful add (resetAfterAdd()), so the next bundle earns its milestones again.
     */

  }, {
    key: "trackMilestones",
    value: function trackMilestones() {
      var _this4 = this;

      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$silent = _ref2.silent,
          silent = _ref2$silent === void 0 ? false : _ref2$silent;

      var config = this.discountConfig();
      var count = (this.selections || []).length;
      (0,_bundle_analytics_js__WEBPACK_IMPORTED_MODULE_7__.unlockedTierMinimums)(config, count).forEach(function (minItems) {
        _this4.tracker.track(_bundle_analytics_js__WEBPACK_IMPORTED_MODULE_7__.BUNDLE_EVENTS.TIER_UNLOCKED, {
          tier_min_items: minItems,
          tier_percentage: (0,_bundle_pricing_js__WEBPACK_IMPORTED_MODULE_3__.discountPercentageFor)(config, minItems)
        }, {
          once: "tier-".concat(minItems),
          silent: silent
        });
      });

      if (this.minItems > 0 && count >= this.minItems) {
        this.tracker.track(_bundle_analytics_js__WEBPACK_IMPORTED_MODULE_7__.BUNDLE_EVENTS.COMPLETED, {}, {
          once: true,
          silent: silent
        });
      }
    } // A shopper can hold at most MAX_BUNDLES bundles at once. The cap is enforced in three places, all of
    // them necessary:
    //   - here, by disabling the add-to-cart button, which is what stops the fixed_price shape too (that
    //     one is posted by cart.js's triggerAdd(), and it honours data-disabled-button);
    //   - again at submit time by submitBundle(), against a freshly fetched cart, because the cart can
    //     change in another tab or from the mini-cart between the last refresh and the click;
    //   - and on the cart's own quantity steppers (cart-item.liquid / syncBundleLimits() in cart.js), so a
    //     bundle line can't be raised past the allowance the rest of the cart leaves.
    // The figure and the counting rules are shared - see ./bundle/limit.js, which src/js/cart.js reads too.

  }, {
    key: "initBundleLimit",
    value: function initBundleLimit() {
      var _this5 = this;

      this.limitWatcher = (0,_bundle_limit_js__WEBPACK_IMPORTED_MODULE_5__.createBundleLimitWatcher)({
        onChange: function onChange() {
          return _this5.updateState();
        }
      });
    }
  }, {
    key: "usesComponentLines",
    value: function usesComponentLines() {
      return (0,_bundle_config_js__WEBPACK_IMPORTED_MODULE_4__.usesComponentLines)(this.discountConfig());
    }
  }, {
    key: "initCartSubmission",
    value: function initCartSubmission() {
      var _this6 = this;

      if (!this.usesComponentLines()) {
        // A fixed_price bundle keeps the original single-line shape, which means an ordinary form post
        // owned by cart.js's delegated [data-atc-button] handler (triggerAdd()) rather than the JSON call
        // below. That handler is the only place that knows the add succeeded, so the reset hangs off the
        // 'theme:cart-added' event it dispatches from the form - a click on the button says nothing about
        // whether the cart took it.
        //
        // Listening on `this`, not on document: the event bubbles out through this element, so it only
        // ever sees its own form, and the listener dies with the element. That matters for
        // BundleModalBuilder, which bundle-modal.js discards and re-renders on every open - a
        // document-level listener would accumulate one dead handler per open.
        this.initFormPostReset();
        return;
      }

      if (!this.atcButton) return; // Capture phase, and propagation is stopped: cart.js binds triggerAdd() to [data-atc-button] on
      // document, which would otherwise post this form the single-line way in parallel with the JSON
      // request below and add the parent twice.

      this.atcButton.addEventListener('click', function (event) {
        return _this6.addBundleToCart(event);
      }, true); // Enter in any field submits the form natively, bypassing the button's click handler entirely -
      // which would post the single-line shape and leave the bundle unpriced.

      var form = this.querySelector('form');
      if (form) form.addEventListener('submit', function (event) {
        return _this6.addBundleToCart(event);
      });
    } // The percentage/tiered_percentage cart shape: ONE LINE PER COMPONENT AND NO PARENT LINE.
    //
    // The parent line was removed by the app's "split logic" change (condition 16). It only ever
    // existed to carry the bundle product's $app:bundle_config metafield into the function, and a
    // merged line lists everything merged into it - so the bundle product appeared in the cart as a
    // child of itself, under its own name. The config now comes from the shop-level
    // $app:bundle_registry, which the function reads with static arguments, so nothing about the
    // bundle product needs to be in the cart at all. `_bundle_parent` names the variant to merge
    // under instead.
    //
    // Sending the old shape against the current app does NOT degrade gracefully. A line declaring
    // _bundle_role: 'parent' is no longer grouped, so it is never merged, and the validator blocks
    // checkout on it as an orphan; and components with no _bundle_parent fail grouping outright
    // (merge_parent_mismatch), so the bundle is not priced. Both halves have to move together.
    //
    // The engine enforces four rules on these properties, all deliberate below:
    //   - _bundle_role is exactly 'component'. 'parent' is the old contract and is refused.
    //   - _bundle_instance is identical across the lines of one bundle, and unique per add.
    //   - _bundle_parent is the bundle product's VARIANT id, identical on every component. It is
    //     matched as a bare numeric id or a full ProductVariant GID and nothing else - it is buyer
    //     input, so anything looser is refused rather than coerced. Components disagreeing about it
    //     are treated as two bundles sharing one token and refused, because pooling them could cross
    //     a tier threshold neither earned.
    //   - _bundle_step is exactly a group id from bundle_config (carried through the DOM as
    //     data-step-id, see product-bundle-2026-step.liquid).
    //   - no price, total or discount value in any property. The engine reads money only off the cart
    //     lines themselves, which Markets has already resolved into the right currency - a price sent
    //     from here would be the wrong one as often as not.
    // The bundle type this builder posts, taken from the same hidden input the form-post (fixed_price)
    // path uses, so the two shapes can never disagree about what kind of bundle this is. Falls back to
    // 'pdp-bundle', which is what this method used to hardcode, so a template that somehow lacks the
    // input behaves exactly as before rather than sending nothing.

  }, {
    key: "bundleTypeFromForm",
    value: function bundleTypeFromForm() {
      var input = this.querySelector('input[name="properties[_bundle_type]"]');
      var value = input && input.value && input.value.trim();
      return value || 'pdp-bundle';
    }
  }, {
    key: "buildCartItems",
    value: function buildCartItems() {
      return (0,_bundle_cart_js__WEBPACK_IMPORTED_MODULE_6__.buildComponentLines)({
        // Read from the form's hidden input rather than hardcoded, because BundleModalBuilder renders the
        // same markup with 'pdp-upsell' - and the order-side Flow groups on that value.
        bundleType: this.bundleTypeFromForm(),
        parentVariantId: this.variantIdInput && this.variantIdInput.value,
        selections: this.selections
      });
    }
  }, {
    key: "addBundleToCart",
    value: function () {
      var _addBundleToCart = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(event) {
        var items, result;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // cart.js's own handler never runs for this button (see initCartSubmission()), so the form's
                // default submit has to be suppressed here too.
                event.preventDefault();
                event.stopPropagation();

                if (!(this.atcButton.disabled || this.atcButton.getAttribute('data-disabled-button') === 'true')) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                items = this.buildCartItems();

                if (items) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                this.atcButton.toggleAttribute('disabled', true); // The completeness guard, the submit-time cap re-check, the POST and its JSON error body, the stash
                // that lets the cart duplicate this bundle, and the UpCart/theme refresh all live in ./bundle/cart.js.

                _context.next = 10;
                return (0,_bundle_cart_js__WEBPACK_IMPORTED_MODULE_6__.submitBundle)(items, {
                  limitWatcher: this.limitWatcher,
                  tracker: this.tracker
                });

              case 10:
                result = _context.sent;

                if (result.ok) {
                  // bundle-modal.js listens for this (on the dialog content, since it bubbles) to close the Edit
                  // Routine dialog once the add has actually succeeded. It can't rely on cart.js's own delegated
                  // [data-atc-button] click handling to know that, or on a same-element bubble-phase click listener
                  // of its own, the way a normal add-to-cart button would: this button's click is bound here in the
                  // capture phase and stopped with stopPropagation() above (see initCartSubmission()), specifically
                  // so cart.js's document-level listener never double-submits this button's form - but that also
                  // means the click event never reaches this element's own bubble phase (or the document at all),
                  // starving any sibling bubble-phase listener on the same node. A dedicated event sidesteps needing
                  // two independently-authored click handlers on one element to agree on propagation order.
                  this.dispatchEvent(new CustomEvent('bundle-builder:added', {
                    bubbles: true
                  })); // Reset AFTER the event, not before: bundle-modal.js closes the drawer on it, so clearing first
                  // would play the whole teardown out in front of the shopper on the way out.

                  this.resetAfterAdd();
                } // updateState() owns the button's disabled state - let it restore whatever the current selection
                // warrants rather than unconditionally re-enabling here.


                this.atcButton.toggleAttribute('disabled', false);
                this.updateState();

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addBundleToCart(_x) {
        return _addBundleToCart.apply(this, arguments);
      }

      return addBundleToCart;
    }() // The fixed_price counterpart to the success branch of addBundleToCart(). It dispatches the same
    // 'bundle-builder:added' event as that path so the drawer still closes on an add (bundle-modal.js
    // listens for it), which is the one thing the two shapes used to disagree about.

  }, {
    key: "initFormPostReset",
    value: function initFormPostReset() {
      var _this7 = this;

      this.addEventListener('theme:cart-added', function () {
        // submitBundle() reports the add for the component-line shape; a form post never goes through it,
        // so without this a fixed_price bundle would emit every event EXCEPT the one that matters. Fired
        // before the reset below, while this.selections still describes what went in.
        //
        // instance_id is empty on purpose: a fixed_price bundle posts no _bundle_instance, so there is no
        // join key from this event to the order. That gap is in the cart shape, not here.
        _this7.tracker.track(_bundle_analytics_js__WEBPACK_IMPORTED_MODULE_7__.BUNDLE_EVENTS.ADDED_TO_CART, {
          instance_id: ''
        });

        _this7.dispatchEvent(new CustomEvent('bundle-builder:added', {
          bubbles: true
        }));

        _this7.resetAfterAdd();
      });
    } // Every bundle surface empties itself once the add has landed, so the next bundle is built from the
    // same blank state the page first rendered - see resetAfterAdd() on BundleGridBuilder and
    // RoutineBuilder, and the override below for the drawer.
    //
    // Back to what the server rendered rather than to nothing: a fixed step (data-bundle-fixed) carries a
    // pre-filled variant id that is part of the bundle rather than a choice of the shopper's, and emptying
    // it would leave a step that can never be completed and a bundle that can never be added again.

  }, {
    key: "resetAfterAdd",
    value: function resetAfterAdd() {
      var _this8 = this;

      this.fields.forEach(function (field) {
        if (field.tagName === 'SELECT') {
          // defaultSelected is the `selected` attribute as rendered, which survives sinkSoldOutOptions()
          // reordering the list - unlike an index captured on connect.
          var initial = Array.from(field.options).find(function (option) {
            return option.defaultSelected;
          });
          field.selectedIndex = initial ? initial.index : 0;
        } else {
          field.value = field.defaultValue;
        } // Stamped on by selectShade(). A fixed step keeps its price: nothing re-stamps it after
        // resolveProductData() has already run, and its value is still selected.


        if (field.dataset.bundleFixed === undefined) delete field.dataset.price;
        delete field.dataset.shadeLabel;
        delete field.dataset.shadeSwatch;
      }); // The sibling a multi-variant <option> writes its shade into (see openSelectShadeDialog()). Cleared
      // with its product attribution, or picking that same product again would silently inherit this
      // shade rather than asking for one.

      this.querySelectorAll('[data-bundle-shade-override]').forEach(function (input) {
        input.value = '';
        input.dataset.productId = '';
        delete input.dataset.price;
        delete input.dataset.shadeLabel;
        delete input.dataset.shadeSwatch;
      }); // The same per-step redraw a change event runs. collectSelections() clears the swatch line itself
      // for a <select> step but not for a shade picker, which has no select to read - hence doing it here
      // for every step rather than leaving it to updateState().

      this.stepEls.forEach(function (stepEl) {
        _this8.renderShadeSwatch(stepEl, '', '');

        _this8.updateStepImage(stepEl);
      });
      this.fields.forEach(function (field) {
        return _this8.updateOptionTitle(field);
      }); // Rewrites the sessionStorage copy as a side effect (persistSelections()), so a refresh after an add
      // doesn't restore the bundle that was just bought.

      this.updateState(); // The form is empty again, so the next bundle should be able to report crossing the same thresholds
      // this one did. Re-seeded afterwards so the clearing itself doesn't emit a removal per step - the
      // shopper didn't take anything out, they bought it.

      this.tracker.reset();
      this.seedTrackedSelections();
    } // Reads back whatever updateState() last persisted for this product and re-applies it to each
    // field before anything else runs, so a refresh doesn't drop the shopper's choices. Silently no-ops
    // if storage is unavailable (private browsing/quota) or holds nothing usable - selections just won't
    // persist in that case, same as before this existed. Handles both a real <select> (steps with more
    // than one product) and the shade-picker's hidden input (see is_shade_picker in
    // product-bundle-2026-step.liquid) - the shade trigger button's own visuals are left to the
    // updateState() call that always follows this, rather than duplicated here.

  }, {
    key: "restoreSelections",
    value: function restoreSelections() {
      var _this9 = this;

      var stored;

      try {
        var raw = sessionStorage.getItem(this.storageKey);
        stored = raw ? JSON.parse(raw) : null;
      } catch (error) {
        return;
      }

      if (!stored) return;
      this.fields.forEach(function (field) {
        var entry = stored[field.name];
        if (!entry || !entry.value) return;

        if (field.tagName === 'SELECT') {
          // A multi-variant option's own value never matches what was stored (that's always the shade
          // override's variant id, not the option's first-variant placeholder - see updateState()), so
          // match by product instead wherever we have one on record.
          // Compared as numeric ids so an entry persisted before the metafield switched from GIDs to
          // bare numeric ids still matches its option rather than silently dropping the selection.
          var option = entry.productId ? Array.from(field.options).find(function (opt) {
            return (0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(opt.dataset.productId) === (0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(entry.productId);
          }) : Array.from(field.options).find(function (opt) {
            return (0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(opt.value) === (0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(entry.value);
          });
          if (!option || option.disabled) return;
          field.value = option.value;

          _this9.updateOptionTitle(field); // A multi-variant option's own value is always just its product's first variant (see
          // updateState()) - it's never what ends up in valuesByName for such a field, only the override
          // ever is. So entry.value here can ONLY have come from a prior override, even on the (fairly
          // common) occasion it happens to equal option.value because the shopper picked that same first
          // variant's shade - checking entry.value !== option.value here would wrongly skip restoring it.


          var variantCount = parseInt(option.dataset.variantCount || '1', 10);

          if (variantCount > 1) {
            var overrideInput = field.closest('[data-bundle-step]').querySelector('[data-bundle-shade-override]');

            if (overrideInput) {
              overrideInput.value = (0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(entry.value);
              overrideInput.dataset.productId = entry.productId ? (0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(entry.productId) : '';
              if (entry.price !== undefined) overrideInput.dataset.price = entry.price;

              if (entry.shadeLabel) {
                overrideInput.dataset.shadeLabel = entry.shadeLabel;
                overrideInput.dataset.shadeSwatch = entry.shadeSwatch || '';

                _this9.renderShadeSwatch(field.closest('[data-bundle-step]'), entry.shadeLabel, entry.shadeSwatch);
              }
            }
          }
        } else {
          field.value = (0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(entry.value);
          if (entry.price !== undefined) field.dataset.price = entry.price;

          if (entry.shadeLabel) {
            field.dataset.shadeLabel = entry.shadeLabel;
            field.dataset.shadeSwatch = entry.shadeSwatch || '';

            _this9.renderShadeSwatch(field.closest('[data-bundle-step]'), entry.shadeLabel, entry.shadeSwatch);
          }

          _this9.updateOptionTitle(field);
        }
      });
    } // Called from updateState() (the single place that already walks every select) rather than
    // duplicating that iteration here.

  }, {
    key: "persistSelections",
    value: function persistSelections(valuesByName) {
      try {
        sessionStorage.setItem(this.storageKey, JSON.stringify(valuesByName));
      } catch (error) {// Storage may be unavailable - selections just won't persist, no functional impact this session.
      }
    } // The step label is its own always-visible element; this only drives the product title line beneath
    // it, which stays hidden while its text is empty (a multi-product step with nothing chosen yet, whose
    // default title is blank - see initial_title in product-bundle-2026-step.liquid). Called for both
    // <select> (multi-product) and hidden input (shade picker) fields; the shade picker calls this after
    // selectShade()/restoreSelections() once a variant is chosen.

  }, {
    key: "updateOptionTitle",
    value: function updateOptionTitle(select) {
      var stepEl = select.closest('[data-bundle-step]');
      var titleEl = stepEl && stepEl.querySelector('[data-bundle-option-title]');
      if (!titleEl) return;

      if (select.selectedOptions) {
        // Regular <select> — show the chosen option's text, or the default (step label) if nothing chosen yet.
        var option = select.selectedOptions[0];
        titleEl.textContent = option && option.value ? option.textContent.trim() : titleEl.dataset.defaultTitle;
      } else {
        // Hidden input — show the product title once a shade is chosen; step label before.
        //
        // Resolved through getActiveStepProduct() rather than straight off the image's
        // data-default-product-id, because selectShade() calls this with the step's
        // [data-bundle-shade-override] input, not only with a shade picker's own field: on a multi-product
        // step that input belongs to whichever product the select currently holds, which is not the step's
        // default one. Reading the default here retitled the step with the default product's name the
        // moment a shade was picked for any other product in the list. A shade-picker step has no select
        // to read, so getActiveStepProduct() falls back to the same default id as before.
        if (select.value) {
          var imageEl = stepEl.querySelector('[data-bundle-option-image]');
          var product = this.getActiveStepProduct(stepEl, imageEl && imageEl.dataset.defaultProductId);
          titleEl.textContent = product ? product.title : titleEl.dataset.defaultTitle;
        } else {
          titleEl.textContent = titleEl.dataset.defaultTitle;
        }
      }

      titleEl.classList.toggle('hidden', !titleEl.textContent.trim());
    } // Used by updateStepImage() below: "whichever product is currently active for this step" (whatever's
    // selected, falling back to the step's default product).

  }, {
    key: "getActiveStepProduct",
    value: function getActiveStepProduct(stepEl, fallbackProductId) {
      var select = stepEl.querySelector('[data-bundle-option-input]');
      var option = select && select.selectedOptions && select.selectedOptions[0];
      var productId = option && option.dataset.productId || fallbackProductId;
      return this.productsById.get(productId);
    } // Swaps in the resolved image for whatever's currently selected in a step. Shows the grey placeholder
    // (empty imageEl, aria-hidden) until the shopper makes an active selection - step label + placeholder
    // is the unselected state; product title + real image is the selected state.
    // No-op until resolveProductData() has populated this.productsById.

  }, {
    key: "updateStepImage",
    value: function updateStepImage(stepEl) {
      if (!stepEl) return;
      var imageEl = stepEl.querySelector('[data-bundle-option-image]');
      if (!imageEl) return; // Single-product steps (no field = fixed product; hidden input = shade picker) always show
      // the image — the product is known, only the shade may still need choosing.
      // Multi-product select steps only show the image once a product has been chosen.

      var field = stepEl.querySelector('[data-bundle-option-input]');
      var hasSelection = !field || field.type === 'hidden' || field.value;
      this.renderStepImage(imageEl, hasSelection ? this.getActiveStepProduct(stepEl, imageEl.dataset.defaultProductId) : null);
    }
  }, {
    key: "renderStepImage",
    value: function renderStepImage(imageEl, product) {
      if (!product || !product.featuredImage) {
        // No active selection (or product has no image) — fall back to the step's own group image from
        // bundle_config, or the shop-level bundle.fallback_thumbnail where the group has none (see
        // product-bundle-2026-step.liquid), otherwise restore the grey placeholder state.
        var fallback = imageEl.dataset.fallbackImage;

        if (!fallback) {
          imageEl.replaceChildren();
          imageEl.setAttribute('aria-hidden', 'true');
          return;
        }

        var placeholderImg = imageEl.querySelector('img');

        if (!placeholderImg) {
          placeholderImg = document.createElement('img');
          placeholderImg.className = 'w-full h-full object-cover rounded-[4px]';
          placeholderImg.loading = 'lazy';
          imageEl.replaceChildren(placeholderImg);
        }

        placeholderImg.src = fallback;
        placeholderImg.alt = '';
        imageEl.removeAttribute('aria-hidden');
        return;
      }

      var img = imageEl.querySelector('img');

      if (!img) {
        img = document.createElement('img');
        img.className = 'w-full h-full object-cover rounded-[4px]';
        img.loading = 'lazy';
        imageEl.replaceChildren(img);
      }

      img.src = product.featuredImage.url;
      img.alt = product.featuredImage.altText || product.title || '';
      imageEl.removeAttribute('aria-hidden');
    } // Every variant this step could ever resolve to - the union across its products for a <select>, or the
    // single field's own list for a shade picker / fixed step (data-variant-ids, see
    // product-bundle-2026-step.liquid).

  }, {
    key: "stepVariantIds",
    value: function stepVariantIds(field) {
      var ids = new Set();

      var addFrom = function addFrom(el) {
        return (el.dataset.variantIds || '').split(',').forEach(function (id) {
          return id && ids.add(id);
        });
      };

      if (field.tagName === 'SELECT') {
        Array.from(field.options).forEach(function (option) {
          if (!option.value) return;
          ids.add(option.value);
          addFrom(option);
        });
      } else {
        if (field.value) ids.add(field.value);
        addFrom(field);
      }

      return Array.from(ids);
    } // True while at least one of these variants can still be sold. An id the Storefront request didn't
    // return counts as available rather than dead, so a partial/failed fetch never greys out something the
    // shopper could actually buy (same rule as productAvailable() in the modal builder).

  }, {
    key: "anyVariantSellable",
    value: function anyVariantSellable(ids) {
      var _this10 = this;

      return ids.some(function (id) {
        var variant = _this10.variantsById.get((0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(id));

        return !variant || variant.availableForSale !== false;
      });
    } // A step is only dead when EVERY variant it could offer is sold out.

  }, {
    key: "stepHasSellableVariant",
    value: function stepHasSellableVariant(field) {
      return this.anyVariantSellable(this.stepVariantIds(field));
    } // Marks steps with nothing sellable left in them, once availability is in. The multi-product case was
    // already half-covered (its options are individually disabled and sunk to the base of the list), but a
    // single-product step - fixed variant or shade picker - had no handling at all: a sold-out fixed step
    // stayed pre-filled and counted as a valid selection until /cart/add rejected it, and a shade picker
    // whose shades had all sold out just left add-to-cart silently dead with nothing naming the cause.
    // Both now read as out of stock, can't be interacted with, and block ATC explicitly via
    // collectSelections().

  }, {
    key: "applyStepAvailability",
    value: function applyStepAvailability() {
      var _this11 = this;

      var unavailableCount = 0;
      this.stepEls.forEach(function (stepEl) {
        var field = stepEl.querySelector('[data-bundle-option-input]');
        if (!field) return;
        var unavailable = !_this11.stepHasSellableVariant(field);
        if (unavailable) unavailableCount += 1;

        if (unavailable) {
          stepEl.dataset.stepUnavailable = 'true';
        } else {
          delete stepEl.dataset.stepUnavailable;
        }

        stepEl.classList.toggle('is-unavailable', unavailable);
        var messageEl = stepEl.querySelector('[data-bundle-step-unavailable]');
        if (messageEl) messageEl.classList.toggle('hidden', !unavailable);
        stepEl.querySelectorAll('[data-bundle-shade-trigger], [data-bundle-product-trigger]').forEach(function (trigger) {
          trigger.toggleAttribute('disabled', unavailable);
        }); // A fixed step's variant is pre-filled by Liquid with no user action behind it - left as-is it
        // would be submitted to the cart. Cleared so it can't be, which is also what makes collectSelections()
        // treat the step as incomplete rather than merely unpriced.

        if (unavailable && field.tagName !== 'SELECT') field.value = '';
      });
      var bundleMessageEl = this.querySelector('[data-bundle-unavailable]');
      if (bundleMessageEl) bundleMessageEl.classList.toggle('hidden', !unavailableCount);
    } // Resolves the image/price/availability the Bundle Engine app's metafield doesn't carry (see
    // sections/product-bundle-2026.liquid) via a single tokenless Storefront API request - confirmed
    // 2026-08-21 against the dev store to need no access token for Product/ProductVariant fields.

  }, {
    key: "resolveProductData",
    value: function () {
      var _resolveProductData = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
        var _this12 = this;

        var optionEls, imageEls, shadeTriggerEls, variantNumerics, productNumerics, addVariantIds, gids, nodes;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                optionEls = Array.from(this.querySelectorAll('[data-bundle-option-input] option[value]:not([value=""])'));
                imageEls = Array.from(this.querySelectorAll('[data-bundle-option-image]'));
                shadeTriggerEls = Array.from(this.shadeTriggerByField.values()); // The bundle_config metafield stores bare numeric ids (v3). Collect them by type so
                // we can build valid GIDs for the Storefront API nodes() query, then key the Maps by
                // bare numeric so every subsequent lookup (using data attributes from the DOM) works
                // without conversion.

                variantNumerics = new Set();
                productNumerics = new Set(); // Every variant of every option, not just the default one in `value` - getStepMaxPrice() needs the
                // full list to price the "buy separately" total shown before anything is selected (see
                // maxVariantPrice()), and sold-out detection below needs to check more than just a multi-variant
                // option's first shade before disabling the whole product.

                addVariantIds = function addVariantIds(el) {
                  (el.dataset.variantIds || '').split(',').forEach(function (id) {
                    if (id) variantNumerics.add(id);
                  });
                };

                optionEls.forEach(function (option) {
                  if (option.value) variantNumerics.add(option.value);
                  addVariantIds(option);
                  if (option.dataset.productId) productNumerics.add(option.dataset.productId);
                }); // The shade-picker branch has no options at all - its whole variant list hangs off the hidden input.

                this.fields.forEach(function (field) {
                  if (field.tagName !== 'SELECT') addVariantIds(field);
                });
                imageEls.forEach(function (imageEl) {
                  if (imageEl.dataset.defaultProductId) productNumerics.add(imageEl.dataset.defaultProductId);
                });
                shadeTriggerEls.forEach(function (trigger) {
                  if (trigger.dataset.productId) productNumerics.add(trigger.dataset.productId);
                });
                gids = [].concat(_toConsumableArray(Array.from(variantNumerics).map(_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toVariantGid)), _toConsumableArray(Array.from(productNumerics).map(_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toProductGid)));

                if (gids.length) {
                  _context2.next = 13;
                  break;
                }

                return _context2.abrupt("return");

              case 13:
                _context2.prev = 13;
                _context2.next = 16;
                return this.fetchBundleNodes(gids);

              case 16:
                nodes = _context2.sent;
                _context2.next = 23;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2["catch"](13);
                console.error('Bundle Builder: could not resolve product data', _context2.t0);
                return _context2.abrupt("return");

              case 23:
                // Key by bare numeric id so DOM data-attribute lookups work directly.
                nodes.forEach(function (node) {
                  if (!node) return;
                  if (node.__typename === 'Product') _this12.productsById.set((0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(node.id), node);
                  if (node.__typename === 'ProductVariant') _this12.variantsById.set((0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(node.id), node);
                }); // Mark sold-out options disabled and (re-)stamp price onto the <option> element from this fetch's
                // own data - always overwritten, not just filled in when unset, because restoreSelections() (run
                // synchronously before this fetch, on every page load) can already have written a stale price here:
                // it seeds data-price straight from sessionStorage, which was captured in whatever Markets
                // country/currency was active when the shopper made that selection. Skipping the overwrite meant a
                // shopper who switched region with a selection already made kept seeing the old market's price/total
                // until they reselected (SBA-979 EU/UK region-switch regression). option.value is a bare numeric
                // variant id (v3 metafield), matching the Map key above.

                optionEls.forEach(function (option) {
                  // Sold out only when EVERY shade of this product is. An <option>'s `value` is just the product's
                  // FIRST variant - for a multi-variant product that's an explicit placeholder, never submitted (the
                  // shopper's real pick lands in [data-bundle-shade-override], see openSelectShadeDialog()) - so
                  // reading availability off it alone struck out a product with in-stock shades still behind it
                  // whenever its first one happened to be out of stock. data-variant-ids carries the full list and
                  // every id in it was fetched above, so the whole product is judged here.
                  var optionVariantIds = (option.dataset.variantIds || option.value || '').split(',').filter(Boolean);
                  if (optionVariantIds.length && !_this12.anyVariantSellable(optionVariantIds)) option.disabled = true; // Price stays keyed to `value`: it's the figure shown against the product before a shade is picked,
                  // and the shade dialog overwrites it with the chosen variant's own price on selection.

                  var variant = _this12.variantsById.get((0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(option.value));

                  if (!variant) return;

                  if (variant.price && variant.price.amount !== undefined) {
                    option.dataset.price = Math.round(parseFloat(variant.price.amount) * 100);
                  }
                }); // The shade-picker's hidden input and a select's shade-override input (see selectShade()) carry no
                // <option>s for the loop above to refresh, so whichever variant either currently points to needs the
                // same live-price refresh applied directly - same stale-after-a-region-switch reasoning as above.

                this.fields.forEach(function (field) {
                  if (field.tagName === 'SELECT' || !field.value) return;

                  var variant = _this12.variantsById.get((0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(field.value));

                  if (variant && variant.price && variant.price.amount !== undefined) {
                    field.dataset.price = Math.round(parseFloat(variant.price.amount) * 100);
                  }
                });
                this.querySelectorAll('[data-bundle-shade-override]').forEach(function (overrideInput) {
                  if (!overrideInput.value) return;

                  var variant = _this12.variantsById.get((0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(overrideInput.value));

                  if (variant && variant.price && variant.price.amount !== undefined) {
                    overrideInput.dataset.price = Math.round(parseFloat(variant.price.amount) * 100);
                  }
                }); // Cached on each field/option now the variant prices are in, so getStepMaxPrice() - called from
                // collectSelections() on every change - is a data-attribute read rather than a re-scan of the
                // variant map. data-variant-ids (see product-bundle-2026-step.liquid) carries every variant a
                // field/option could resolve to, not just its current value, so this covers shades not yet picked.

                optionEls.forEach(function (option) {
                  var maxPrice = _this12.maxVariantPrice(option.dataset.variantIds);

                  if (maxPrice !== undefined) option.dataset.maxPrice = maxPrice;
                });
                this.fields.forEach(function (field) {
                  if (field.tagName === 'SELECT') return;

                  var maxPrice = _this12.maxVariantPrice(field.dataset.variantIds);

                  if (maxPrice !== undefined) field.dataset.maxPrice = maxPrice;
                }); // Sold-out products sink to the base of their step's list once availability resolves, rather than
                // staying wherever the metafield happened to order them.

                this.fields.forEach(function (field) {
                  if (field.tagName === 'SELECT') _this12.sinkSoldOutOptions(field);
                }); // Only the image is shown on the step itself. Short descriptions appear in the product shelf alone,
                // and resolveShortDescriptions() below fetches them for that.

                this.stepEls.forEach(function (stepEl) {
                  return _this12.updateStepImage(stepEl);
                }); // The shade dialog needs a real product handle to fetch ?view=variant-selector-2026 - the trigger
                // stays disabled (can't be clicked) until that's resolved.

                shadeTriggerEls.forEach(function (trigger) {
                  var product = _this12.productsById.get((0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(trigger.dataset.productId));

                  if (!product || !product.handle) return;
                  trigger.dataset.productHandle = product.handle;
                  trigger.removeAttribute('disabled');
                }); // Stamp prices on pre-filled fixed hidden inputs (single-product, single-variant steps).
                // For shade pickers the price is set by selectShade(); for fixed inputs there is no user
                // interaction, so the Storefront price must be written here instead.

                this.fields.forEach(function (field) {
                  if (field.tagName === 'SELECT') return;
                  if (field.dataset.price !== undefined) return; // already priced (e.g. shade picker set by selectShade)

                  if (_this12.shadeTriggerByField.has(field)) return; // shade picker — price set when shade chosen

                  if (!field.value) return;

                  var variant = _this12.variantsById.get((0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(field.value));

                  if (variant && variant.price && variant.price.amount !== undefined) {
                    field.dataset.price = Math.round(parseFloat(variant.price.amount) * 100);
                  }
                }); // Everything above resolves what a step COULD offer; this settles what it still can, and has to run
                // after the shade triggers are enabled above so a dead step's trigger stays disabled.

                this.applyStepAvailability(); // Re-run now real prices/availability are in, so the hero price and disabled state catch up.

                this.updateState(); // Last, so the view is counted against a builder that is fully resolved and the baseline is seeded
                // from what survived availability rather than from what the metafield proposed.

                this.startTracking();
                this.resolveShortDescriptions();

              case 37:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[13, 19]]);
      }));

      function resolveProductData() {
        return _resolveProductData.apply(this, arguments);
      }

      return resolveProductData;
    }() // The short description isn't read via the Storefront GraphQL request above - a product's custom
    // metafield needs the `unauthenticated_read_metafields` access scope granted to whatever Storefront
    // API client is making that request, which isn't guaranteed to be configured (confirmed 2026-08-26:
    // ACCESS_DENIED against this store's tokenless access). Server-rendered Liquid has full metafield
    // access with no such scope, so this fetches a bare per-product view instead (same
    // ?view=<template> pattern openShadeDialog() already uses for the shade dialog) - one small request
    // per distinct product a step could show, run after resolveProductData() so product.handle is known.
    //
    // Only the product shelf (openProductDialog()) shows them. The step itself used to as well, and no
    // longer does: the description line was taken off the PDP steps, kept in the shelf and the Edit
    // Routine drawer. The shelf only opens for a <select> step, so its options are the whole set.

  }, {
    key: "resolveShortDescriptions",
    value: function () {
      var _resolveShortDescriptions = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3() {
        var _this13 = this;

        var productIds;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                productIds = new Set();
                this.querySelectorAll('[data-bundle-option-input] option[data-product-id]').forEach(function (option) {
                  productIds.add(option.dataset.productId);
                });
                _context3.next = 4;
                return Promise.all(Array.from(productIds).map(function (id) {
                  return _this13.resolveShortDescription(id);
                }));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function resolveShortDescriptions() {
        return _resolveShortDescriptions.apply(this, arguments);
      }

      return resolveShortDescriptions;
    }()
  }, {
    key: "resolveShortDescription",
    value: function () {
      var _resolveShortDescription = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(productId) {
        var product, html;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                product = this.productsById.get((0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(productId));

                if (!(!product || !product.handle)) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                _context4.next = 5;
                return (0,_bundle_fragments_js__WEBPACK_IMPORTED_MODULE_8__.fetchFragment)((0,_bundle_fragments_js__WEBPACK_IMPORTED_MODULE_8__.productViewUrl)(product.handle, 'bundle-short-description-2026'), {
                  label: 'bundle short description'
                });

              case 5:
                html = _context4.sent;

                if (!(html === null)) {
                  _context4.next = 8;
                  break;
                }

                return _context4.abrupt("return");

              case 8:
                product.shortDescription = {
                  value: html.trim()
                };

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function resolveShortDescription(_x2) {
        return _resolveShortDescription.apply(this, arguments);
      }

      return resolveShortDescription;
    }() // Dearest BUYABLE variant, in cents, among a comma-separated id list (data-variant-ids, see
    // product-bundle-2026-step.liquid). Feeds the "bought separately" ceiling shown before anything is
    // picked (see getStepMaxPrice() and collectSelections()' maxTotal).
    //
    // Sold-out variants are excluded, agreed 2026-09-30. This used to count every variant regardless while
    // getProductMaxPriceCents() in bundle-card-price.js excluded them, so a PDP and its own product card
    // quoted different savings for the same bundle. maxSellablePrice() in ./bundle/pricing.js now owns the
    // rule for both, including what happens when a step has nothing buyable in it at all.
    //
    // Undefined only when none of the ids resolved a price.

  }, {
    key: "maxVariantPrice",
    value: function maxVariantPrice(idsAttr) {
      var _this14 = this;

      var entries = (idsAttr || '').split(',').filter(Boolean).map(function (rawId) {
        return _this14.variantsById.get((0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(rawId));
      }).filter(function (variant) {
        return variant && variant.price;
      }).map(function (variant) {
        return {
          cents: (0,_bundle_pricing_js__WEBPACK_IMPORTED_MODULE_3__.toCents)(variant.price.amount),
          available: variant.availableForSale !== false
        };
      });
      return (0,_bundle_pricing_js__WEBPACK_IMPORTED_MODULE_3__.maxSellablePrice)(entries);
    } // The most a step could contribute to the "buy separately" total: the dearest variant of its dearest
    // product, regardless of current stock/market availability (see maxVariantPrice() above). Used for
    // steps the shopper hasn't chosen yet, so the compare-at price on load reflects the full bundle at its
    // maximum rather than only whatever's been picked so far (which would otherwise start at nothing and
    // climb). Undefined until resolveProductData() has priced the step - the hero then just keeps its
    // server-rendered seed.

  }, {
    key: "getStepMaxPrice",
    value: function getStepMaxPrice(field) {
      if (field.tagName !== 'SELECT') {
        return field.dataset.maxPrice === undefined ? undefined : parseInt(field.dataset.maxPrice, 10);
      }

      var max;
      Array.from(field.options).forEach(function (option) {
        // Only the empty placeholder is skipped - every real option counts toward the ceiling regardless
        // of its own disabled/sold-out state, matching maxVariantPrice() above.
        if (!option.value) return;
        var raw = option.dataset.maxPrice !== undefined ? option.dataset.maxPrice : option.dataset.price;
        if (raw === undefined) return;
        var price = parseInt(raw, 10);
        if (max === undefined || price > max) max = price;
      });
      return max;
    } // How many items a fully-maxed-out bundle counts as, for the tiered-discount rate updateState() shows
    // alongside maxTotal before anything's been picked (see discountPercentageFor(), which keys off item
    // count, not cents). One per field here, since this builder is a hard single-pick-per-step design -
    // overridden by BundleModalBuilder, where a step can hold up to its own `max`.

  }, {
    key: "maxItemCount",
    value: function maxItemCount() {
      return this.fields.length;
    } // Reorders a step's <select> so every sold-out option (already flagged `disabled` above) sits below
    // every in-stock option, with the placeholder option (value="") pinned first regardless. Relative
    // order within each group is otherwise left as the metafield provided it. appendChild() on an
    // already-present option moves it rather than duplicating it, and moving options doesn't change
    // select.value (tracked by the option element, not its index), so the current selection survives.

  }, {
    key: "sinkSoldOutOptions",
    value: function sinkSoldOutOptions(select) {
      var options = Array.from(select.options);
      var placeholder = options.find(function (option) {
        return !option.value;
      });
      var real = options.filter(function (option) {
        return option.value;
      });
      var available = real.filter(function (option) {
        return !option.disabled;
      });
      var soldOut = real.filter(function (option) {
        return option.disabled;
      });
      var ordered = placeholder ? [placeholder].concat(_toConsumableArray(available), _toConsumableArray(soldOut)) : [].concat(_toConsumableArray(available), _toConsumableArray(soldOut));
      ordered.forEach(function (option) {
        return select.appendChild(option);
      });
    } // Formats a price resolved via the Storefront request above, in the currency that request actually
    // returned (this.currencyCode - see resolveProductData()) rather than the shop's static default
    // window.theme.moneyFormat (set once at page load from shop.money_format, see javascript-lang.liquid),
    // which reflects only the shop's default market and can carry the wrong symbol for a shopper browsing
    // in a different one. Falls back to that static format only if no currency has come back yet (nothing
    // fetched, or the request failed) or the returned code isn't one Intl recognises.

  }, {
    key: "formatBundleMoney",
    value: function formatBundleMoney(cents) {
      // trimTrailingZeros matches the theme's own money_without_trailing_zeros card markup - the same
      // bundle was rendering as "€80.00" here and "€80" on its card.
      return (0,_bundle_pricing_js__WEBPACK_IMPORTED_MODULE_3__.formatBundleMoney)(cents, this.currencyCode, {
        trimTrailingZeros: true
      });
    }
  }, {
    key: "fetchBundleNodes",
    value: function () {
      var _fetchBundleNodes = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(ids) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", (0,_bundle_storefront_js__WEBPACK_IMPORTED_MODULE_2__.fetchBundleNodes)(ids, {
                  country: this.marketCountry,
                  fields: _bundle_storefront_js__WEBPACK_IMPORTED_MODULE_2__.BUNDLE_NODE_FIELDS
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function fetchBundleNodes(_x3) {
        return _fetchBundleNodes.apply(this, arguments);
      }

      return fetchBundleNodes;
    }() // Wires up every shade-picker trigger button (is_shade_picker in product-bundle-2026-step.liquid) to
    // open the bundle's own dialog (snippets/bundle-shade-selector.liquid) - a separate element from the
    // standard PDP's [data-variant-selector-dialog] (see src/js/variant-selector.js) because that one is
    // hardcoded to write the chosen variant into the page's single [data-product-main] form, which here
    // would be this bundle's own add-to-cart form rather than the step being edited.

  }, {
    key: "initShadeTriggers",
    value: function initShadeTriggers() {
      var _this15 = this;

      // Maps each shade-picker's hidden input to its sibling trigger button - built once here rather than
      // re-derived via closest()/querySelectorAll() on every updateState() call (fired on every field
      // change).
      this.shadeTriggerByField = new Map();
      this.querySelectorAll('[data-bundle-shade-trigger]').forEach(function (trigger) {
        var control = trigger.closest('.bundle-step-control');
        var field = control && control.querySelector('[data-bundle-option-input]');
        if (field) _this15.shadeTriggerByField.set(field, trigger);
      });
      this.shadeDialog = document.querySelector('[data-bundle-shade-dialog]');
      if (!this.shadeDialog) return;
      this.shadeDialogContent = this.shadeDialog.querySelector('[data-bundle-shade-dialog-content]');
      var closeBtn = this.shadeDialog.querySelector('[data-bundle-shade-dialog-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () {
        return _this15.closeShadeDialog();
      });
      this.shadeTriggerByField.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          return _this15.openShadeDialogForTrigger(trigger);
        });
      });
    } // Maps each multi-product step's hidden select to its visible trigger button, and wires each trigger
    // to open the product-picker drawer (snippets/bundle-product-selector.liquid). Built once here for
    // the same reason as initShadeTriggers() - updateState() is the hot path and shouldn't re-walk DOM.

  }, {
    key: "initProductTriggers",
    value: function initProductTriggers() {
      var _this16 = this;

      this.productTriggerByField = new Map();
      this.querySelectorAll('[data-bundle-product-trigger]').forEach(function (trigger) {
        var control = trigger.closest('.bundle-step-control');
        var field = control && control.querySelector('[data-bundle-option-input]');
        if (field) _this16.productTriggerByField.set(field, trigger);
      });
      this.productDialog = document.querySelector('[data-bundle-product-dialog]');
      if (!this.productDialog) return;
      this.productDialogContent = this.productDialog.querySelector('[data-bundle-product-dialog-content]');
      var closeBtn = this.productDialog.querySelector('[data-bundle-product-dialog-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () {
        return _this16.closeProductDialog();
      });
      this.productTriggerByField.forEach(function (trigger, field) {
        trigger.addEventListener('click', function () {
          return _this16.openProductDialog(trigger, field);
        });
      });
    }
  }, {
    key: "closeProductDialog",
    value: function closeProductDialog() {
      (0,_bundle_drawer_js__WEBPACK_IMPORTED_MODULE_9__.closeDrawer)(this.productDialog);
    } // Builds the product-picker drawer content from the already-resolved productsById/variantsById data
    // (no extra fetch - resolveProductData() already ran) and shows the dialog. Each item in the list
    // is a button; clicking one updates the step's hidden select, dispatches a change event so the
    // existing listener handles title/image/description/updateState updates, then closes the drawer.
    // If the chosen product is itself multi-variant (data-variant-count > 1) the existing change listener
    // also opens the shade dialog - no special handling needed here.

  }, {
    key: "openProductDialog",
    value: function openProductDialog(trigger, field) {
      var _this17 = this;

      if (!this.productDialog) return;
      this.activeProductTarget = {
        trigger: trigger,
        field: field
      };
      var stepEl = field.closest('[data-bundle-step]');
      var stepLabel = stepEl && stepEl.dataset.stepLabel || ''; // Build list items from the select's real <option> elements - their data-* attributes were already
      // stamped by Liquid and their dataset.price filled in by resolveProductData(). Skips the empty
      // placeholder option (value=""). Layout mirrors the bundle-modal-product-row grid in theme 204068258135:
      // 72px image | product name + price | 24px checkbox.

      var options = Array.from(field.options).filter(function (opt) {
        return opt.value;
      });
      var listItems = options.map(function (opt) {
        var productId = (0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(opt.dataset.productId);

        var product = _this17.productsById.get(productId);

        var image = product && product.featuredImage;
        var title = product ? product.title : opt.textContent.trim();
        var price = opt.dataset.price !== undefined ? parseInt(opt.dataset.price, 10) : undefined;
        var isSelected = field.value && (0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(field.value) === (0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(opt.value);
        var isOos = opt.disabled;
        var mediaHtml = image ? "<div class=\"bundle-modal-product-media\"><img src=\"".concat(image.url, "\" alt=\"").concat(image.altText || title, "\" class=\"w-full h-full object-contain\" loading=\"lazy\"></div>") : "<div class=\"bundle-modal-product-media\"></div>";
        var priceHtml = price !== undefined ? "<span class=\"text-sm text-charcoal-70\">".concat(_this17.formatBundleMoney(price), "</span>") : '';
        var shortDescription = product && product.shortDescription && product.shortDescription.value;
        var descriptionHtml = shortDescription ? "<p class=\"text-sm text-charcoal-70\">".concat(shortDescription, "</p>") : '';
        var oosLabel = isOos ? "<span class=\"text-sm text-charcoal-50\">Sold out</span>" : '';
        return "<div class=\"bundle-modal-product-row".concat(isSelected ? ' is-picked' : '').concat(isOos ? ' is-oos' : '', "\" data-product-option-value=\"").concat(opt.value, "\" data-product-option-id=\"").concat(productId, "\">\n        ").concat(mediaHtml, "\n        <div class=\"flex flex-col gap-1.5 min-w-0\">\n          <span class=\"font-medium\">").concat(title, "</span>\n          ").concat(descriptionHtml, "\n          ").concat(priceHtml, "\n          ").concat(oosLabel, "\n        </div>\n        <input type=\"checkbox\" class=\"bundle-modal-product-checkbox\"").concat(isSelected ? ' checked' : '', " aria-label=\"").concat(title, "\" tabindex=\"-1\" readonly>\n      </div>");
      });
      this.productDialogContent.innerHTML = "\n      <div class=\"px-3 pt-5 pb-2\">\n        <h3 class=\"text-[18px] leading-normal font-sans font-medium\">".concat(stepLabel, "</h3>\n      </div>\n      <div class=\"grow px-3 relative overflow-auto pb-5\">\n        <div class=\"flex flex-col\">").concat(listItems.join(''), "</div>\n      </div>"); // Wire each row div - dispatch a real change event so the existing listener (which handles
      // updateOptionTitle / updateStepImage / updateState / openSelectShadeDialog)
      // runs exactly as if the shopper had used the native select.

      this.productDialogContent.querySelectorAll('[data-product-option-value]').forEach(function (row) {
        if (row.classList.contains('is-oos')) return;
        row.addEventListener('click', function () {
          field.value = row.dataset.productOptionValue;
          field.dispatchEvent(new Event('change', {
            bubbles: true
          }));

          _this17.closeProductDialog();
        });
      });
      (0,_bundle_drawer_js__WEBPACK_IMPORTED_MODULE_9__.openDrawer)(this.productDialog);
    }
  }, {
    key: "closeShadeDialog",
    value: function closeShadeDialog() {
      (0,_bundle_drawer_js__WEBPACK_IMPORTED_MODULE_9__.closeDrawer)(this.shadeDialog);
    } // Entry point for the single-product shade-picker branch (is_shade_picker in
    // product-bundle-2026-step.liquid) - its trigger button already carries the resolved product handle.

  }, {
    key: "openShadeDialogForTrigger",
    value: function openShadeDialogForTrigger(trigger) {
      var stepEl = trigger.closest('[data-bundle-step]');
      var input = stepEl && stepEl.querySelector('[data-bundle-option-input]'); // Passing the step's current value (if any) pre-highlights the shopper's existing pick when
      // reopening, same as the standard PDP dialog does for its own form. The ?variant= query param
      // wants Shopify's plain numeric id; the stored value is already bare numeric (v3 metafield),
      // so toNumericId() is a safe no-op that also handles any legacy GID-stored value.

      var currentValue = input && input.value;
      this.openShadeDialog({
        kind: 'shade-picker',
        stepEl: stepEl,
        input: input,
        handle: trigger.dataset.productHandle,
        currentNumericId: currentValue && (0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(currentValue)
      });
    } // Entry point for a <select> step whose just-chosen option is itself multi-variant (data-variant-count
    // > 1 in product-bundle-2026-step.liquid). The option's own value is only ever that product's first variant (a placeholder, never meant to be submitted as-is);
    // the shopper's real pick lands in the step's [data-bundle-shade-override] hidden input instead, once
    // resolved via the same dialog the single-product picker uses.

  }, {
    key: "openSelectShadeDialog",
    value: function openSelectShadeDialog(stepEl, option) {
      var product = this.productsById.get((0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(option.dataset.productId)); // Not resolved yet (resolveProductData() hasn't returned) - shouldn't normally be reachable since a
      // shopper can't pick this option before the select itself renders, but the handle is required.

      if (!product || !product.handle) return;
      var overrideInput = stepEl.querySelector('[data-bundle-shade-override]');
      if (!overrideInput) return; // Only pre-highlight/keep the previous shade if it belongs to THIS product - switching the select to
      // a different multi-variant product (or back to it) shouldn't carry over an unrelated shade pick.

      var overrideMatches = (0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(overrideInput.dataset.productId) === (0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(option.dataset.productId) && overrideInput.value;
      this.openShadeDialog({
        kind: 'select-option',
        stepEl: stepEl,
        option: option,
        overrideInput: overrideInput,
        handle: product.handle,
        currentNumericId: overrideMatches ? (0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(overrideInput.value) : null
      });
    } // Fetches the exact same ?view=variant-selector-2026 fragment the standard PDP's shade dialog uses
    // (see product-variants-2026.liquid for the swatch/code/description row markup) for the target
    // product, and binds each row's click to selectShade() instead of variant-selector.js's own handler.
    // `target` is either a shade-picker (hidden input) or select-option (the <select>'s multi-variant
    // option) descriptor - see openShadeDialogForTrigger()/openSelectShadeDialog() above.

  }, {
    key: "openShadeDialog",
    value: function () {
      var _openShadeDialog = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6(target) {
        var _this18 = this;

        var url, rendered;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (target.handle) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return");

              case 2:
                this.activeShadeTarget = target;
                url = (0,_bundle_fragments_js__WEBPACK_IMPORTED_MODULE_8__.productViewUrl)(target.handle, 'variant-selector-2026', {
                  variant: target.currentNumericId || ''
                }); // Fails soft, matching resolveProductData()/resolveShortDescription() elsewhere in this file - leaves
                // the dialog closed rather than showing broken/error-page content in it.

                _context6.next = 6;
                return (0,_bundle_fragments_js__WEBPACK_IMPORTED_MODULE_8__.renderFragmentInto)(this.shadeDialogContent, url, {
                  label: 'shade selector'
                });

              case 6:
                rendered = _context6.sent;

                if (rendered) {
                  _context6.next = 9;
                  break;
                }

                return _context6.abrupt("return");

              case 9:
                // product-variants-2026.liquid stamps data-variant-oos on any variant that isn't available - those
                // rows stay visible (so the shade range still reads complete) but must not be selectable here.
                (0,_bundle_drawer_js__WEBPACK_IMPORTED_MODULE_9__.bindVariantRows)(this.shadeDialogContent, function (event) {
                  return _this18.selectShade(event);
                });
                (0,_bundle_drawer_js__WEBPACK_IMPORTED_MODULE_9__.openDrawer)(this.shadeDialog);

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function openShadeDialog(_x4) {
        return _openShadeDialog.apply(this, arguments);
      }

      return openShadeDialog;
    }() // A shade row was clicked - carry its variant id/price into whichever field the active dialog target
    // (see openShadeDialog()) is for, reading price straight off the dialog's own [data-variants-json]
    // (the same real Liquid-rendered variant data product-variants-2026.liquid already embeds, rather than
    // a separate fetch), and let updateState() pick up the rest (trigger/select look, totals, ATC state,
    // persistence).

  }, {
    key: "selectShade",
    value: function selectShade(event) {
      var target = this.activeShadeTarget;
      if (!target) return; // product-variants-2026.liquid renders data-variant-id as Shopify's plain numeric variant id.
      // The bundle_config metafield (v3) also stores bare numeric ids, so field values are kept as
      // bare numeric throughout - no GID conversion needed or wanted here.

      var numericVariantId = event.currentTarget.dataset.variantId; // The clicked label already carries everything the selected-swatch line under the title needs -
      // its shade name (data-label-value) and, for colour swatches, the swatch <img> product-variants-2026.
      // liquid renders inside it (see the is_colour branch there). Non-colour options have no such <img>,
      // so the dot just falls back to its plain CSS background (see .bundle-step-swatch-dot).

      var shadeLabel = event.currentTarget.dataset.labelValue || '';
      var swatchImg = event.currentTarget.querySelector('img');
      var shadeSwatch = swatchImg ? swatchImg.src : '';
      var price;
      var variantsJsonEl = this.shadeDialogContent.querySelector('[data-variants-json]');

      if (variantsJsonEl) {
        try {
          var variants = JSON.parse(variantsJsonEl.textContent);
          var variant = variants.find(function (entry) {
            return String(entry.id) === String(numericVariantId);
          });
          if (variant && variant.price !== undefined) price = variant.price;
        } catch (error) {// Fail soft - price just won't be set yet; it'll catch up next time resolveProductData() runs.
        }
      }

      var field = target.kind === 'shade-picker' ? target.input : target.overrideInput;
      field.value = numericVariantId;
      field.dataset.shadeLabel = shadeLabel;
      field.dataset.shadeSwatch = shadeSwatch;
      if (price !== undefined) field.dataset.price = price;
      if (target.kind === 'select-option') field.dataset.productId = target.option.dataset.productId;
      this.renderShadeSwatch(target.stepEl, shadeLabel, shadeSwatch); // The whole step is re-synced, not just its title: a shade pick on a multi-product step is the tail
      // of a product change (picking a multi-variant product opens this dialog, see
      // openSelectShadeDialog()), so the image belongs to the newly chosen product too. It reads the
      // select's current option, so it lands on the right product either way.

      this.updateOptionTitle(field);
      this.updateStepImage(target.stepEl);
      this.closeShadeDialog();
      this.updateState();
    } // Shows/fills the selected-shade line under a step's title (data-bundle-option-swatch-wrap, see
    // is_shade_picker in product-bundle-2026-step.liquid) - a no-op for steps that don't render it (the
    // multi-product select branch has no swatch line, only its own title/CHANGE control).

  }, {
    key: "renderShadeSwatch",
    value: function renderShadeSwatch(stepEl, label, swatchUrl) {
      var wrap = stepEl && stepEl.querySelector('[data-bundle-option-swatch-wrap]');
      if (!wrap) return;
      var dot = wrap.querySelector('[data-bundle-option-swatch]');
      var labelEl = wrap.querySelector('[data-bundle-option-swatch-label]');
      if (dot) dot.style.backgroundImage = swatchUrl ? "url(".concat(swatchUrl, ")") : '';
      if (labelEl) labelEl.textContent = label || '';
      wrap.classList.toggle('hidden', !label);
      wrap.classList.toggle('flex', Boolean(label));
    } // Walks the per-step fields and returns everything updateState()'s shared tail needs. Overridden by
    // BundleModalBuilder (SBA-982), whose stage UI keeps its own per-group selection state rather than one
    // value per <select> - a step there can hold up to its group's `max` items. Everything AFTER this in
    // updateState() (pricing, _bundle_selections serialisation, persistence, ATC gating) is deliberately
    // shared: group attribution and GID normalisation are the easiest things to let drift between two
    // implementations, and the cart/Bundle Engine contract depends on both.

  }, {
    key: "collectSelections",
    value: function collectSelections() {
      var _this19 = this;

      var selectionEntries = [];
      var valuesByName = {};
      var total = 0; // What the bundle would cost with nothing chosen: every step at the dearest option it could
      // contribute. Only ever shown in that state - see the hero update at the base of this method.

      this.maxTotal = 0;
      var hasPrices = true; // The ATC button should only look/act enabled once every category has a real selection - confirmed
      // 2026-08-21, deliberately stricter than the bundle's own min_items (which would allow fewer).

      var missingSelection = false; // Steps included automatically rather than chosen: a single product with a single variant, pre-filled
      // by Liquid (data-bundle-fixed, see product-bundle-2026-step.liquid). They belong in the cart and in
      // the total, but they are NOT the shopper making a choice - so the hero keeps showing the full
      // "bought separately" ceiling until a real selection happens, rather than dropping to the price of
      // whatever was auto-included.

      var autoIncludedCount = 0;
      this.fields.forEach(function (field) {
        var _field$closest, _field$closest2;

        var isSelect = field.tagName === 'SELECT'; // Carried into _bundle_selections below - the app rejects a selection with no group attribution.

        var groupId = (_field$closest = field.closest('[data-bundle-step]')) === null || _field$closest === void 0 ? void 0 : _field$closest.dataset.stepId; // Nothing sellable left in this step (see applyStepAvailability()) - it can never be completed, so
        // the bundle can't be added. Skipped entirely rather than left to the empty-value branch below, so a
        // sold-out step also drops out of the "bought separately" maxTotal it could no longer contribute to.

        if (((_field$closest2 = field.closest('[data-bundle-step]')) === null || _field$closest2 === void 0 ? void 0 : _field$closest2.dataset.stepUnavailable) === 'true') {
          missingSelection = true;
          return;
        } // The shade-picker branch (is_shade_picker in product-bundle-2026-step.liquid) uses a hidden
        // input instead of a <select> - its placeholder/CHANGE look lives on the sibling trigger button,
        // set here from selectShade()/restoreSelections() rather than driven by the field itself.


        var shadeTrigger = isSelect ? null : _this19.shadeTriggerByField.get(field); // A <select>'s chosen <option> can itself be multi-variant (data-variant-count > 1) - its own value is only ever that product's first variant, a placeholder
        // never meant to be submitted. The shopper's real pick (if any) lives in the step's sibling
        // [data-bundle-shade-override] instead (see openSelectShadeDialog()/selectShade()), keyed to the
        // same product so switching the select away and back doesn't carry over a stale shade.

        var effectiveValue = field.value;
        var effectivePrice;
        var effectiveShadeLabel;
        var effectiveShadeSwatch;
        var effectiveProductId;

        if (isSelect) {
          var option = field.selectedOptions[0];
          var variantCount = option ? parseInt(option.dataset.variantCount || '1', 10) : 1;
          effectiveProductId = option && option.dataset.productId;

          if (option && option.value && variantCount > 1) {
            var overrideInput = field.closest('[data-bundle-step]').querySelector('[data-bundle-shade-override]');
            var overrideMatches = overrideInput && (0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(overrideInput.dataset.productId) === (0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(option.dataset.productId) && overrideInput.value;
            effectiveValue = overrideMatches ? overrideInput.value : '';
            effectivePrice = overrideMatches ? overrideInput.dataset.price : undefined;
            effectiveShadeLabel = overrideMatches ? overrideInput.dataset.shadeLabel : undefined;
            effectiveShadeSwatch = overrideMatches ? overrideInput.dataset.shadeSwatch : undefined;
          } else {
            effectivePrice = option && option.dataset.price;
          } // CSS alone can't style the placeholder state for an optional select - an empty value there is
          // valid, so :invalid never matches it the way it does for a required select. Driven off
          // effectiveValue (not the select's own raw value) so a multi-variant option picked but not yet
          // resolved via the shade dialog still reads as incomplete.


          field.classList.toggle('is-placeholder', !effectiveValue); // Keep the visible product trigger button in sync with the hidden select's placeholder state -
          // the trigger uses .is-placeholder to swap between its "Select a product" and "CHANGE" labels
          // (see .bundle-step-product-trigger in product-bundle-2026.scss), exactly as the shade trigger
          // does for the is_shade_picker branch.

          var productTrigger = _this19.productTriggerByField && _this19.productTriggerByField.get(field);

          if (productTrigger) productTrigger.classList.toggle('is-placeholder', !effectiveValue); // Clears a stale swatch when the shopper moves the select to a single-variant product or back to
          // the placeholder - effectiveShadeLabel is only set above when the override still belongs to the
          // currently selected product. No-op for steps with no swatch line (see renderShadeSwatch()).

          _this19.renderShadeSwatch(field.closest('[data-bundle-step]'), effectiveShadeLabel, effectiveShadeSwatch);
        } else if (shadeTrigger) {
          // The trigger renders both its placeholder and its "CHANGE" label up front (see
          // product-bundle-2026-step.liquid) and swaps them via .is-placeholder in CSS, rather than being
          // rewritten with textContent here - the mobile "CHANGE" state is a pencil icon, which textContent
          // can't carry, and a CSS toggle also reverts correctly if the value is ever cleared.
          shadeTrigger.classList.toggle('is-placeholder', !field.value);
          effectivePrice = field.dataset.price;
          effectiveShadeLabel = field.dataset.shadeLabel;
          effectiveShadeSwatch = field.dataset.shadeSwatch;
          effectiveProductId = shadeTrigger.dataset.productId;
        } else {
          // Fixed hidden input — single-product, single-variant step. Value pre-filled by Liquid,
          // price stamped by resolveProductData() once the Storefront fetch returns.
          effectivePrice = field.dataset.price;
          effectiveProductId = field.dataset.productId;
          if (field.dataset.bundleFixed !== undefined && field.value) autoIncludedCount += 1;
        }

        if (!effectiveValue) {
          // Every category's field reads as "Select an option"/"Select a shade" now, with no separate
          // "opt out" choice - so an empty value blocks the ATC button regardless of whether the
          // category itself is required.
          missingSelection = true; // Feeds the nothing-selected figure only (see maxTotal above): the most this step could add.
          // A step that can't be priced this way (nothing in stock, or a variant the Storefront request
          // didn't return) is simply left out rather than suppressing the figure altogether.

          var stepMax = _this19.getStepMaxPrice(field);

          if (stepMax !== undefined) _this19.maxTotal += stepMax;
          return;
        } // An auto-included step contributes to the ceiling too - it's part of the bundle either way, and
        // leaving it out is what made the nothing-selected figure undercount by exactly its price.


        if (field.dataset.bundleFixed !== undefined) {
          var fixedMax = _this19.getStepMaxPrice(field);

          var fixedPrice = fixedMax !== undefined ? fixedMax : parseInt(effectivePrice, 10);
          if (!Number.isNaN(fixedPrice) && fixedPrice !== undefined) _this19.maxTotal += fixedPrice;
        }

        valuesByName[field.name] = {
          value: effectiveValue,
          productId: effectiveProductId,
          price: effectivePrice,
          shadeLabel: effectiveShadeLabel,
          shadeSwatch: effectiveShadeSwatch
        };
        selectionEntries.push({
          variantGid: effectiveValue,
          group: groupId,
          productId: effectiveProductId,
          price: effectivePrice,
          shadeLabel: effectiveShadeLabel
        });

        if (effectivePrice !== undefined) {
          total += parseInt(effectivePrice, 10);
        } else {
          hasPrices = false;
        }
      });
      return {
        selectionEntries: selectionEntries,
        valuesByName: valuesByName,
        total: total,
        hasPrices: hasPrices,
        missingSelection: missingSelection,
        autoIncludedCount: autoIncludedCount
      };
    }
  }, {
    key: "updateState",
    value: function updateState() {
      var _this20 = this;

      // Both collectSelections() implementations report autoIncludedCount; the default keeps this working
      // for any future override that doesn't.
      var _this$collectSelectio = this.collectSelections(),
          selectionEntries = _this$collectSelectio.selectionEntries,
          valuesByName = _this$collectSelectio.valuesByName,
          total = _this$collectSelectio.total,
          hasPrices = _this$collectSelectio.hasPrices,
          missingSelection = _this$collectSelectio.missingSelection,
          _this$collectSelectio2 = _this$collectSelectio.autoIncludedCount,
          autoIncludedCount = _this$collectSelectio2 === void 0 ? 0 : _this$collectSelectio2;

      var belowMin = this.minItems > 0 && selectionEntries.length < this.minItems;
      var aboveMax = this.maxItems > 0 && selectionEntries.length > this.maxItems; // hasPrices only ever goes false once every step has a value but resolveProductData()'s Storefront
      // fetch hasn't caught up yet - never true while missingSelection is (the loop returns before the
      // price check for an empty field), so this doesn't change the "nothing selected yet" disabled state.
      // Blocks ATC on a slow connection, where the compare-at total submitted to the cart would otherwise
      // be stale.

      var disabled = missingSelection || belowMin || aboveMax || !hasPrices || this.limitWatcher.reached; // Kept for the component-line cart shape (see addBundleToCart()), which builds its payload from the
      // live selection rather than from the _bundle_selections property.

      this.selections = selectionEntries; // Both read this.selections, so they run once it is current and before anything below can change it
      // again. Inert until startTracking() opens them - see trackSelectionDelta().

      this.trackSelectionDelta();
      if (this.trackingReady) this.trackMilestones(); // _bundle_selections is the fixed_price shape only - a percentage/tiered_percentage bundle sends its
      // components as their own cart lines instead, and the engine expects the property to be absent
      // there. Left empty rather than merely unsubmitted so nothing can post a stale one by another route.

      if (this.selectionsInput && this.usesComponentLines()) {
        this.selectionsInput.value = '';
      } else if (this.selectionsInput) {
        // Written as {variant_id, product_id, quantity, title, image, price} per selection - richer than
        // just the variant id - so the cart drawer/cart page (see snippets/cart-item.liquid) can render
        // each bundled product's own thumbnail/title/price straight from the line item's own properties,
        // with no further lookup. All the data going in here (productsById/variantsById) was already
        // fetched for the PDP's own image/price rendering by resolveProductData() above - nothing new is
        // fetched just for this. Numeric ids (as the metafield itself now carries them) to match what
        // cart-item.liquid can trivially work with elsewhere in the theme (Shopify's own line item/variant
        // ids are always numeric). String or number form is equally fine for the app itself - it matches
        // on idKey(), which normalises both.
        //
        // `group` is the one key the app REQUIRES beyond variant_id/quantity: a bundle_config with groups
        // (every steps bundle) rejects an unattributed selection outright as "missing_group", and checks
        // each pick against its own group's variant whitelist rather than the union - see
        // evaluateStructure() in shared/bundle-rules.js of the functions app. Sourced from the step's
        // data-step-id (see product-bundle-2026-step.liquid), i.e. the metafield group's own id.
        this.selectionsInput.value = JSON.stringify(selectionEntries.map(function (entry) {
          var product = _this20.productsById.get((0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(entry.productId));

          var title = entry.shadeLabel && product ? "".concat(product.title, " - ").concat(entry.shadeLabel) : product && product.title;
          return {
            variant_id: (0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(entry.variantGid),
            product_id: entry.productId ? (0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(entry.productId) : undefined,
            quantity: 1,
            group: entry.group || undefined,
            title: title || undefined,
            image: product && product.featuredImage && product.featuredImage.url,
            price: entry.price !== undefined ? parseInt(entry.price, 10) : undefined
          };
        }));
      }

      this.persistSelections(valuesByName); // Only the shopper's own choices switch the hero off its ceiling figure - an auto-included fixed step
      // is present from first paint and would otherwise drop the hero to that one product's price before
      // anything had actually been picked.

      var chosenCount = selectionEntries.length - autoIncludedCount;

      if (hasPrices && chosenCount > 0) {
        this.updateHeroSaving(total, selectionEntries.length);
      } else if (chosenCount === 0 && this.maxTotal > 0) {
        // Priced as though every step were chosen (which is what maxTotal assumes), so a tiered discount
        // shows at the rate a complete bundle would earn rather than the nothing-selected rate of zero.
        // maxItemCount() (not just this.fields.length) because BundleModalBuilder overrides it - it never
        // sets this.fields at all (it deliberately skips super.connectedCallback(), see its class comment),
        // so reading this.fields.length directly here throws for that subclass, silently aborting this
        // whole method before updateHeroSaving() ever runs (confirmed: this branch was simply never reached
        // for BundleModalBuilder before maxTotal started resolving to a real figure for it).
        this.updateHeroSaving(this.maxTotal, this.maxItemCount());
      }

      if (this.atcButton) {
        this.atcButton.toggleAttribute('disabled', disabled);
        this.atcButton.setAttribute('data-disabled-button', disabled ? 'true' : 'false');
      }

      if (this.ctaLabelEl) {
        // "Choose options" would be a lie when every option IS chosen and it's the cart that's full, so the
        // limit gets its own label. Falls back to the incomplete label if a template hasn't declared one.
        if (this.limitWatcher.reached) {
          this.ctaLabelEl.textContent = this.ctaLabelEl.dataset.labelLimit || this.ctaLabelEl.dataset.labelIncomplete;
        } else {
          this.ctaLabelEl.textContent = disabled ? this.ctaLabelEl.dataset.labelIncomplete : this.ctaLabelEl.dataset.labelReady;
        }
      }
    } // The percentage off `itemCount` selections earns under this bundle's config: a flat rate for
    // "percentage", or the highest tier the count reaches for "tiered_percentage" (tiers aren't
    // guaranteed to arrive sorted, so this takes the best match rather than the last one). Anything else,
    // including a config with no discount set, is treated as 0% rather than guessed at.
    // The { discountType, discountPercentage, discountTiers } shape ./bundle/pricing.js takes.

  }, {
    key: "discountConfig",
    value: function discountConfig() {
      return {
        discountType: this.discountType,
        discountPercentage: this.discountPercentage,
        discountTiers: this.discountTiers
      };
    }
  }, {
    key: "discountPercentageFor",
    value: function discountPercentageFor(itemCount) {
      return (0,_bundle_pricing_js__WEBPACK_IMPORTED_MODULE_3__.discountPercentageFor)(this.discountConfig(), itemCount);
    } // What `total` worth of components actually costs as a bundle, in cents. Display only - the real
    // discount is applied at checkout by the Bundle Engine function, which this mirrors.

  }, {
    key: "applyDiscount",
    value: function applyDiscount(total, itemCount) {
      return (0,_bundle_pricing_js__WEBPACK_IMPORTED_MODULE_3__.applyDiscount)(this.discountConfig(), total, itemCount);
    } // Rewrites the whole hero price row from the current selection: the price is what the bundle actually
    // costs (the discounted component total, or the bundle variant's own price for a fixed_price bundle -
    // see bundleDisplayPrice() below), the struck-through compare-at is what those same products would
    // cost bought separately, and the badge is the gap between the two. `total` is the raw undiscounted
    // sum, and `itemCount` how many selections it represents - needed on its own because a tiered discount
    // rate depends on the count, not the value.
    //
    // With nothing picked yet updateState() passes this.maxTotal (every step's dearest in-stock option)
    // rather than 0, so the row opens on the largest figure the bundle can reach and then tracks the live
    // selection from the first pick onwards. That holds for fixed_price too: only the struck-through side
    // moves there, since the price itself is fixed whatever the shopper chooses.

  }, {
    key: "updateHeroSaving",
    value: function updateHeroSaving(total, itemCount) {
      // THE BUNDLE PRODUCT'S OWN PRICE IS WHAT A fixed_price BUNDLE COSTS, AND IS NOT PART OF WHAT A
      // percentage/tiered ONE COSTS. The two shapes are exact opposites here, which is why this goes
      // through one shared rule (bundleDisplayPrice() in ./bundle/pricing.js) rather than being decided
      // inline - the product card and 5 Minute Face need the same answer and used to each guess at it.
      //
      // Both halves of that have been wrong in this method before:
      //
      // percentage/tiered: this used to ADD data-fixed-price to both figures whenever usesComponentLines()
      // was true, justified by a comment saying the parent variant is posted as a separate, undiscounted
      // cart line. True on SBA-979; not true since SBA-982 removed the parent line, and the Bundle Engine's
      // cart transform is unambiguous (extensions/bundle-engine/src/index.js in the functions app):
      //
      //   "no parent cart line is needed to reach it, so no parent cart line goes into the merge"
      //   "the merge base is the component sum alone, so the percentage the shopper should get IS the
      //    percentage we emit ... with the parent gone there is nothing to cancel"
      //
      // fixed_price: and then the opposite error, which this change fixes. applyDiscount() returns `total`
      // untouched for this type, so the hero quoted the component sum as the price, computed a saving of
      // exactly 0 from it, and hid the compare-at and the saving badge on that - leaving a fixed-price
      // bundle showing one unremarkable number that was not even the number at checkout. The parent line's
      // own Markets-resolved cost IS the bundle total on the expand path, so that is the price, and the
      // component sum beside it is the genuine "bought separately" figure to strike through.
      var displayPrice = (0,_bundle_pricing_js__WEBPACK_IMPORTED_MODULE_3__.bundleDisplayPrice)(this.discountConfig(), total, itemCount, this.fixedPrice);
      var displayTotal = total; // Derived from the two displayed figures, not from the pre-discount pair - for fixed_price the gap is
      // between the component sum and the parent's price, and there is no percentage anywhere in it. Stays
      // <= 0 (so the compare-at and badge below stay hidden) when a bundle is priced at or above what its
      // components cost separately, which is a real merchandising state and not worth shouting about.

      var saving = displayTotal - displayPrice;

      if (this.heroPriceEl) {
        this.heroPriceEl.textContent = this.formatBundleMoney(displayPrice);
      }

      if (this.heroSavingEl) {
        this.heroSavingEl.classList.toggle('hidden', saving <= 0);
      }

      if (this.heroSavingAmountEl && saving > 0) {
        this.heroSavingAmountEl.textContent = this.formatBundleMoney(saving);
      }

      if (this.heroCompareAtPriceEl) {
        this.heroCompareAtPriceEl.classList.toggle('hidden', saving <= 0);

        if (saving > 0) {
          this.heroCompareAtPriceEl.textContent = this.formatBundleMoney(displayTotal);
        }
      } // Carries the same total through to the cart line item (see _bundle_compare_at_price in
      // product-bundle-2026.liquid) so the cart shows this same figure rather than whatever compare-at
      // Shopify would otherwise compute for the line.


      if (this.compareAtInput) {
        this.compareAtInput.value = displayTotal;
      }
    }
  }]);

  return BundleBuilder;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('bundle-builder', BundleBuilder); // SBA-982: the "Edit Routine" modal's builder. Extends BundleBuilder for its shared tail - updateState()'s
// pricing/serialisation/persistence/ATC gating, updateHeroSaving(), fetchBundleNodes() and
// resolveShortDescription() - but deliberately does NOT call super.connectedCallback(): the base wires
// itself to one <select> (or shade-trigger) per step, and this UI has neither. Everything DOM-facing is
// overridden; everything contract-facing (group attribution, GID normalisation, the cart properties) is
// inherited, so the two builders can't drift on the bits the Bundle Engine and cart depend on.
//
// The one substantive model difference, confirmed 2026-09-01: a group's `max` is real here. Where the
// standalone builder is a hard single-pick-per-step design, a step in this modal can hold up to `max`
// items, so selection state is a groupId -> array map rather than one value per field. That's why
// collectSelections() is overridden rather than the base's field walk being reused.

var BundleModalBuilder = /*#__PURE__*/function (_BundleBuilder) {
  _inherits(BundleModalBuilder, _BundleBuilder);

  var _super2 = _createSuper(BundleModalBuilder);

  function BundleModalBuilder() {
    _classCallCheck(this, BundleModalBuilder);

    return _super2.apply(this, arguments);
  }

  _createClass(BundleModalBuilder, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this21 = this;

      // The drawer renders its own hero inside itself, unlike the standalone builder whose hero lives up in
      // the PDP's [data-product-main].
      this.initBundleContext({
        heroRoot: this
      });
      this.steps = Array.from(this.querySelectorAll('[data-bundle-step]')).map(function (el) {
        var products = [];
        var json = el.querySelector('[data-bundle-step-products]');

        try {
          products = json ? JSON.parse(json.textContent) : [];
        } catch (error) {
          console.error('Bundle Modal: could not parse step products', error);
        }

        return {
          el: el,
          id: el.dataset.stepId,
          label: el.dataset.stepLabel || '',
          // A group with no explicit max still allows exactly one, matching the standalone builder.
          min: parseInt(el.dataset.stepMin || '0', 10),
          max: parseInt(el.dataset.stepMax || '1', 10) || 1,
          fixed: el.hasAttribute('data-step-fixed'),
          // The group's own fallback image from bundle_config, if it has one (see bundle-modal-step.liquid).
          image: el.dataset.stepImage || '',
          products: products,
          linesEl: el.querySelector('[data-bundle-step-lines]'),
          changeBtn: el.querySelector('[data-bundle-step-change]')
        };
      }); // groupId -> array of { variantGid, productId, price, shadeLabel, shadeSwatch }. The array form is the
      // whole point of this subclass (see the class comment) - a step may hold up to its group's `max`.

      this.selectionsByGroup = new Map(); // Keyed separately from the standalone builder's own store: the same shopper can have a bundle PDP and
      // this modal open against the same bundle product, and they're independent selections.

      this.storageKey = "bundle-modal-selections:".concat(this.dataset.productId);
      this.stageEls = new Map();
      this.querySelectorAll('[data-bundle-stage]').forEach(function (el) {
        return _this21.stageEls.set(el.dataset.bundleStage, el);
      }); // Navigation is a stack rather than a flat current-stage value: stage 3 pops back to stage 2 (where the
      // shopper came from and where their shade now shows), and stage 2 pops back to stage 1.

      this.stageStack = ['steps'];
      this.seedFixedSteps();
      this.restoreSelections();
      this.bindEvents();
      this.initCartSubmission(); // Inherited from BundleBuilder - this subclass doesn't call super.connectedCallback(), so the bundle
      // cap has to be wired up here too, or the upsell would be the one way past it.

      this.initBundleLimit();
      this.renderAllStepLines();
      this.showStage('steps');
      this.updateState();
      this.resolveProductData();
    } // A step whose single product has a single variant isn't a choice - it's part of the routine (the Figma
    // design's "Complexion Duo Brush" row: no CHANGE control). Seed it as selected so it counts towards
    // min_items/pricing, shows its own product image and title rather than a "select a product" prompt, and
    // the shopper isn't blocked on a step they can't act on.

  }, {
    key: "seedFixedSteps",
    value: function seedFixedSteps() {
      var _this22 = this;

      this.steps.forEach(function (step) {
        if (!step.fixed) return;
        var entry = step.products[0];
        if (!entry) return;

        _this22.selectionsByGroup.set(step.id, [{
          variantGid: String((entry.variant_ids || [])[0]),
          productId: entry.product_id
        }]);
      });
    }
    /* ------------------------------------------------------------------ persistence */
    // Own shape (groupId -> array) rather than the base's field-name -> single value, so the base's
    // restoreSelections() can't be reused.

  }, {
    key: "restoreSelections",
    value: function restoreSelections() {
      var _this23 = this;

      var stored;

      try {
        var raw = sessionStorage.getItem(this.storageKey);
        stored = raw ? JSON.parse(raw) : null;
      } catch (error) {
        return;
      }

      if (!stored) return;
      this.steps.forEach(function (step) {
        // Fixed steps are re-seeded from the config above rather than trusted from storage, in case the
        // bundle's config changed since the shopper's last visit.
        if (step.fixed) return;
        var picks = stored[step.id];
        if (!Array.isArray(picks) || !picks.length) return; // Drop anything no longer offered by this step, and re-apply the group's own max, so a config change
        // between sessions can't restore a selection the Bundle Engine would now reject.

        var allowed = new Set(step.products.map(function (entry) {
          return entry.product_id;
        }));
        var valid = picks.filter(function (pick) {
          return pick && pick.variantGid && allowed.has(pick.productId);
        }).slice(0, step.max);
        if (valid.length) _this23.selectionsByGroup.set(step.id, valid);
      });
    }
    /* ------------------------------------------------------------------ selection state */

  }, {
    key: "getPicks",
    value: function getPicks(groupId) {
      return this.selectionsByGroup.get(groupId) || [];
    }
  }, {
    key: "isPicked",
    value: function isPicked(groupId, productId) {
      return this.getPicks(groupId).some(function (pick) {
        return pick.productId === productId;
      });
    } // Returns true when the selection changed. A step at its `max` blocks further picks, EXCEPT where max is
    // 1, where picking replaces - a single-pick list that silently ignores the shopper's tap would read as
    // broken, whereas a genuinely multi-pick one needs them to uncheck something first.

  }, {
    key: "togglePick",
    value: function togglePick(step, entry, shade) {
      var picks = this.getPicks(step.id).slice();
      var existing = picks.findIndex(function (pick) {
        return pick.productId === entry.product_id;
      });

      if (existing > -1 && !shade) {
        picks.splice(existing, 1);
        this.selectionsByGroup.set(step.id, picks);
        return true;
      }

      var pick = {
        variantGid: shade && shade.variantGid || (entry.variant_ids || [])[0],
        productId: entry.product_id,
        price: shade && shade.price,
        shadeLabel: shade && shade.shadeLabel,
        shadeSwatch: shade && shade.shadeSwatch
      };

      if (existing > -1) {
        picks[existing] = pick;
      } else if (step.max === 1) {
        picks.splice(0, picks.length, pick);
      } else if (picks.length < step.max) {
        picks.push(pick);
      } else {
        return false;
      }

      this.selectionsByGroup.set(step.id, picks);
      return true;
    } // Overrides the base's field walk. Gating here follows each GROUP's own min/max from the bundle JSON
    // (confirmed 2026-09-01) rather than the base's "every step must have a value" rule - a group with
    // min: 0 is genuinely skippable in this UI.

  }, {
    key: "collectSelections",
    value: function collectSelections() {
      var _this24 = this;

      var selectionEntries = [];
      var valuesByName = {};
      var total = 0;
      var hasPrices = true;
      var missingSelection = false; // Same meaning as the base class's own count (see its collectSelections()): picks that are part of the
      // routine rather than something the shopper chose - here the fixed steps seeded by seedFixedSteps().
      // updateState() subtracts these before deciding whether anything has been picked, which is what keeps
      // the hero on its ceiling figure. Without it a drawer whose bundle happens to contain one fixed step
      // opened showing that single product's price (£13/£11.05 for the Brow Duo Brush, rather than the
      // £77/£65.45 ceiling the product card and upsell CTA show for the same bundle) - a real figure, but
      // not one representative of the bundle.

      var autoIncludedCount = 0; // What the bundle would cost with every step maxed out at its priciest selectable products - the
      // base class only accumulates this for whichever fields are still unselected (see its own
      // collectSelections()), but since updateState() only ever reads it while NOTHING has been picked at
      // all (selectionEntries.length === 0), that's equivalent to summing every step here unconditionally.
      // Without this, updateState()'s "nothing selected yet" branch never fires (this.maxTotal stayed
      // undefined - the base's own initialisation of it lives in the collectSelections() this override
      // replaces), and the hero price is left showing its server-rendered seed - the bundle variant's own
      // Admin price, which is 0 for a percentage/tiered_percentage bundle (see usesComponentLines()) - as
      // £0.00 on first opening the Edit Routine drawer.
      // A step with nothing sellable in it contributes nothing: the shopper can't buy that item, so counting
      // it would claim a "bought separately" total - and a saving off it - that isn't available to them.
      // Matches the standalone builder, whose own collectSelections() drops an unavailable step before it
      // reaches maxTotal, and bundle-card-price.js's getProductMaxPriceCents().

      this.maxTotal = this.steps.reduce(function (sum, step) {
        if (_this24.unavailableStepIds && _this24.unavailableStepIds.has(step.id)) return sum;
        return sum + _this24.stepMaxTotal(step);
      }, 0);
      this.steps.forEach(function (step) {
        var picks = _this24.getPicks(step.id);

        valuesByName[step.id] = picks;
        if (picks.length < step.min || picks.length > step.max) missingSelection = true;
        if (_this24.unavailableStepIds && _this24.unavailableStepIds.has(step.id)) missingSelection = true;
        picks.forEach(function (pick) {
          if (pick.unavailable) return; // Counted off the entries actually pushed, not off step.fixed alone: a fixed step whose variant
          // has sold out returns above, so counting it here would make chosenCount go negative.

          if (step.fixed) autoIncludedCount += 1;
          selectionEntries.push({
            variantGid: pick.variantGid,
            group: step.id,
            productId: pick.productId,
            price: _this24.priceFor(pick),
            shadeLabel: pick.shadeLabel
          });

          var price = _this24.priceFor(pick);

          if (price !== undefined) {
            total += parseInt(price, 10);
          } else {
            hasPrices = false;
          }
        });
      });
      return {
        selectionEntries: selectionEntries,
        valuesByName: valuesByName,
        total: total,
        hasPrices: hasPrices,
        missingSelection: missingSelection,
        autoIncludedCount: autoIncludedCount
      };
    } // The most a step could contribute: its dearest selectable product's price - deliberately only ONE
    // product per step, same as the base class's getStepMaxPrice() and bundle-card-price.js's
    // getStepMaxPriceCents(), even though this modal's own selection mechanics genuinely allow up to
    // step.max picks per step (see class comment). Reverted from summing the top step.max prices
    // 2026-09-21 (SBA-979): a group configured with max > 1 inflated this modal's "nothing picked yet"
    // ceiling above what the PDP/product card/upsell-drawer widget all show for the exact same bundle -
    // all three assume one product per step regardless of a group's own max, and the ceiling has to read
    // the same figure across every surface a shopper might see it on, not just be internally consistent
    // with what this one UI would let them pick. maxVariantPrice() is inherited from the base class
    // unchanged; it already ignores current availability (see its own comment).

  }, {
    key: "stepMaxTotal",
    value: function stepMaxTotal(step) {
      var _this25 = this;

      var prices = (step.products || []).map(function (entry) {
        return _this25.maxVariantPrice((entry.variant_ids || []).join(','));
      }).filter(function (price) {
        return price !== undefined;
      });
      return prices.length ? Math.max.apply(Math, _toConsumableArray(prices)) : 0;
    } // Overrides the base class's maxItemCount(): counts one item per step, same as stepMaxTotal() above -
    // the base's own maxItemCount() (this.fields.length) already means exactly this for the standalone
    // builder (one field per step there too), this subclass just can't read it off this.fields, since it
    // never sets that (see connectedCallback() skipping super.connectedCallback()).

  }, {
    key: "maxItemCount",
    value: function maxItemCount() {
      return this.steps.length;
    } // A shade pick carries its own price (read off the variant-selector fragment's [data-variants-json], same
    // as the base's selectShade()); anything else falls back to whatever resolveProductData() resolved for
    // that variant.

  }, {
    key: "priceFor",
    value: function priceFor(pick) {
      if (pick.price !== undefined && pick.price !== null && pick.price !== '') return pick.price;
      var variant = this.variantsById.get(pick.variantGid);

      if (variant && variant.price && variant.price.amount !== undefined) {
        return Math.round(parseFloat(variant.price.amount) * 100);
      }

      return undefined;
    }
    /* ------------------------------------------------------------------ data resolution */
    // BundleModalBuilder collects IDs from this.steps (the parsed bundle_config metafield), not from DOM
    // shade triggers or <option> elements - those are only wired up in BundleBuilder. The base's
    // resolveProductData() must NOT be called from this subclass: it reads this.shadeTriggerByField,
    // which is only initialised via initShadeTriggers() in BundleBuilder.connectedCallback(), which this
    // subclass deliberately skips.

  }, {
    key: "resolveProductData",
    value: function () {
      var _resolveProductData2 = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee7() {
        var _this26 = this;

        var variantNumerics, productNumerics, _iterator, _step, step, _iterator2, _step2, entry, _iterator3, _step3, id, gids, nodes;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                variantNumerics = new Set();
                productNumerics = new Set();
                _iterator = _createForOfIteratorHelper(this.steps);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    step = _step.value;
                    _iterator2 = _createForOfIteratorHelper(step.products || []);

                    try {
                      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                        entry = _step2.value;
                        if (entry.product_id) productNumerics.add(String(entry.product_id));
                        _iterator3 = _createForOfIteratorHelper(entry.variant_ids || []);

                        try {
                          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                            id = _step3.value;
                            variantNumerics.add(String(id));
                          }
                        } catch (err) {
                          _iterator3.e(err);
                        } finally {
                          _iterator3.f();
                        }
                      }
                    } catch (err) {
                      _iterator2.e(err);
                    } finally {
                      _iterator2.f();
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                gids = [].concat(_toConsumableArray(Array.from(variantNumerics).map(_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toVariantGid)), _toConsumableArray(Array.from(productNumerics).map(_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toProductGid)));

                if (gids.length) {
                  _context7.next = 7;
                  break;
                }

                return _context7.abrupt("return");

              case 7:
                _context7.prev = 7;
                _context7.next = 10;
                return this.fetchBundleNodes(gids);

              case 10:
                nodes = _context7.sent;
                _context7.next = 17;
                break;

              case 13:
                _context7.prev = 13;
                _context7.t0 = _context7["catch"](7);
                console.error('Bundle Builder: could not resolve product data', _context7.t0);
                return _context7.abrupt("return");

              case 17:
                // Key by bare numeric id so config lookups (pick.variantGid, entry.product_id) work directly.
                nodes.forEach(function (node) {
                  if (!node) return;
                  if (node.__typename === 'Product') _this26.productsById.set((0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(node.id), node);
                  if (node.__typename === 'ProductVariant') _this26.variantsById.set((0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(node.id), node);
                });
                this.applyStepAvailability();
                this.renderAllStepLines();
                this.updateState();
                this.startTracking();
                this.resolveShortDescriptions();

              case 23:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[7, 13]]);
      }));

      function resolveProductData() {
        return _resolveProductData2.apply(this, arguments);
      }

      return resolveProductData;
    }() // First in-stock variant of the first in-stock product in a step, in the order the metafield lists them.
    // Returns null when the step has nothing sellable at all, which is what makes the whole bundle
    // unavailable (see applyStepAvailability()).

  }, {
    key: "firstAvailableSelection",
    value: function firstAvailableSelection(step) {
      var _this27 = this;

      var _iterator4 = _createForOfIteratorHelper(step.products),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var entry = _step4.value;
          var variantId = (entry.variant_ids || []).find(function (id) {
            var variant = _this27.variantsById.get(String(id));

            return !variant || variant.availableForSale !== false;
          });
          if (variantId) return {
            entry: entry,
            variantGid: String(variantId)
          };
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return null;
    } // Reconciles every step against live stock, once, after resolveProductData(). Two jobs, in order:
    // drop any pick restored from sessionStorage whose variant has since sold out; record steps that have
    // NO sellable variant at all, which disable add-to-cart and surface
    // the "bundle unavailable" message. Variable steps that are empty after the stock filter are left
    // empty - the shopper selects rather than having a default pre-chosen for them.

  }, {
    key: "applyStepAvailability",
    value: function applyStepAvailability() {
      var _this28 = this;

      if (this.defaultsSeeded) return;
      this.defaultsSeeded = true;
      this.unavailableStepIds = new Set();
      this.steps.forEach(function (step) {
        var inStock = _this28.getPicks(step.id).filter(function (pick) {
          var variant = _this28.variantsById.get(String(pick.variantGid));

          return !variant || variant.availableForSale !== false;
        });

        if (inStock.length !== _this28.getPicks(step.id).length) _this28.selectionsByGroup.set(step.id, inStock);
        if (inStock.length) return;

        var fallback = _this28.firstAvailableSelection(step);

        if (!fallback) {
          _this28.unavailableStepIds.add(step.id);

          var first = step.products[0];

          if (first) {
            _this28.selectionsByGroup.set(step.id, [{
              variantGid: String((first.variant_ids || [])[0]),
              productId: first.product_id,
              shadeLabel: '',
              shadeSwatch: '',
              unavailable: true
            }]);
          }
        } // Available variants exist but step is empty: leave it empty so the shopper picks.

      });
      this.renderUnavailableState();
    } // Only a multi-variant product gets a shade line - a single-variant product's variant title is Shopify's
    // "Default Title" placeholder, which would read as a nonsense shade name.

  }, {
    key: "defaultShadeLabel",
    value: function defaultShadeLabel(entry, variant) {
      var variantCount = parseInt(entry.variant_count || '1', 10);
      if (variantCount <= 1) return '';
      var title = variant && variant.title;
      if (!title || title === 'Default Title') return '';
      return title;
    } // The message is bundle-level (one dead step is enough to make the bundle unaddable), but the CHANGE
    // controls are disabled PER STEP: confirmed 2026-09-02 that a step with at least one product carrying at
    // least one viable variant must still allow a selection, even while a different step is dead. Disabling
    // every step because one of them sold out locked shoppers out of steps they could still act on, and made
    // it impossible to tell which step was the problem - the disabled control is now that indicator.

  }, {
    key: "renderUnavailableState",
    value: function renderUnavailableState() {
      var unavailableIds = this.unavailableStepIds || new Set();
      var messageEl = this.querySelector('[data-bundle-unavailable]');
      if (messageEl) messageEl.classList.toggle('hidden', !unavailableIds.size);
      this.steps.forEach(function (step) {
        if (!step.changeBtn) return;
        step.changeBtn.toggleAttribute('disabled', unavailableIds.has(step.id));
      });
    } // Same per-product Liquid view fetch as the base (a product's custom metafield isn't readable over
    // tokenless Storefront access - see the base's resolveShortDescriptions()), but over every product in
    // every step rather than the ones a <select> happens to hold. resolveShortDescription() itself is the
    // base's and writes onto the same productsById entries.

  }, {
    key: "resolveShortDescriptions",
    value: function () {
      var _resolveShortDescriptions2 = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee8() {
        var _this29 = this;

        var productIds;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                productIds = new Set();
                this.steps.forEach(function (step) {
                  step.products.forEach(function (entry) {
                    if (entry.product_id) productIds.add(entry.product_id);
                  });
                });
                _context8.next = 4;
                return Promise.all(Array.from(productIds).map(function (id) {
                  return _this29.resolveShortDescription(id);
                }));

              case 4:
                this.renderAllStepLines();
                this.refreshOpenProductStage();

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function resolveShortDescriptions() {
        return _resolveShortDescriptions2.apply(this, arguments);
      }

      return resolveShortDescriptions;
    }()
  }, {
    key: "productAvailable",
    value: function productAvailable(productId) {
      var product = this.productsById.get(productId); // Unresolved yet - treat as available rather than greying the whole list out on a slow connection.

      if (!product) return true;
      return product.availableForSale !== false;
    }
  }, {
    key: "shortDescriptionFor",
    value: function shortDescriptionFor(productId) {
      var product = this.productsById.get(productId);
      return product && product.shortDescription && product.shortDescription.value || '';
    }
    /* ------------------------------------------------------------------ stage navigation */

  }, {
    key: "showStage",
    value: function showStage(name) {
      this.stageEls.forEach(function (el, key) {
        var active = key === name;
        el.classList.toggle('hidden', !active);
        el.toggleAttribute('hidden', !active);
      });
      this.updateState();
    } // Stages 2 and 3 reuse stage 1's add-to-cart button as a "confirm and go back" control, so its label is
    // pinned and its disabled state cleared: a sub-selection is always confirmable, even while the bundle as
    // a whole is still incomplete. Applied from updateState() rather than showStage() so a later state pass
    // (a stage-2 checkbox change, resolveProductData() landing) can't overwrite it with the bundle's own
    // incomplete/ready label.

  }, {
    key: "pinConfirmCta",
    value: function pinConfirmCta() {
      // A full cart outranks the stage's own CTA: this method exists to force the button enabled on stages
      // 2/3 (where the step selection is deliberately incomplete), and doing that when the bundle cap is
      // already reached would hand back an ATC the add path then refuses.
      if (this.limitWatcher.reached) return;
      if (this.ctaLabelEl) this.ctaLabelEl.textContent = this.ctaLabelEl.dataset.labelConfirm;

      if (this.atcButton) {
        this.atcButton.removeAttribute('disabled');
        this.atcButton.setAttribute('data-disabled-button', 'false');
      }
    }
  }, {
    key: "updateState",
    value: function updateState() {
      _get(_getPrototypeOf(BundleModalBuilder.prototype), "updateState", this).call(this); // stageStack is set up before the first updateState() in connectedCallback, but guard anyway - the base
      // constructor path must not depend on subclass state existing.


      if (this.stageStack && this.currentStage() !== 'steps') this.pinConfirmCta();
    } // The base class resets form fields; this drawer has none to reset - its selection is the group map,
    // and its "form" is the stage stack. Same contract, different shape of state.
    //
    // Clearing matters more here than anywhere else: bundle-modal.js throws this element away and fetches
    // it again on every open, so the only thing carrying a bundle between opens is the sessionStorage copy
    // restoreSelections() reads. Left alone, reopening the drawer would rebuild the routine just bought.

  }, {
    key: "resetAfterAdd",
    value: function resetAfterAdd() {
      this.selectionsByGroup.clear(); // Fixed steps are part of the routine rather than a choice, so they come straight back - exactly as
      // they are seeded on first render.

      this.seedFixedSteps(); // Back to stage one. The drawer is closing on this same add, but it reopens onto whatever stage it
      // was left at, which would otherwise be the shade picker of a routine that no longer exists.

      this.stageStack = ['steps'];
      this.showStage('steps');
      this.renderAllStepLines(); // Rewrites the sessionStorage copy, same as the base class - see persistSelections().

      this.updateState(); // As the base class: milestones start again, and the clearing itself is not a removal.

      this.tracker.reset();
      this.seedTrackedSelections();
    }
  }, {
    key: "pushStage",
    value: function pushStage(name) {
      this.stageStack.push(name);
      this.showStage(name);
    } // Pops back one stage. Returns false when already at stage 1, so the caller (the dialog's close button)
    // knows to close the modal instead.

  }, {
    key: "popStage",
    value: function popStage() {
      if (this.stageStack.length <= 1) return false;
      this.stageStack.pop();
      var name = this.stageStack[this.stageStack.length - 1];
      if (name === 'products') this.refreshOpenProductStage();
      if (name === 'steps') this.renderAllStepLines();
      this.showStage(name);
      return true;
    }
  }, {
    key: "currentStage",
    value: function currentStage() {
      return this.stageStack[this.stageStack.length - 1];
    }
    /* ------------------------------------------------------------------ events */

  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this30 = this;

      this.steps.forEach(function (step) {
        if (!step.changeBtn) return;
        step.changeBtn.addEventListener('click', function () {
          return _this30.openProductStage(step);
        });
      }); // The footer CTA is a real submit inside the form so cart.js's delegated [data-atc-button] handler adds
      // the bundle on stage 1. On stages 2 and 3 the same button means "confirm this sub-selection", so the
      // submit is cancelled here before it can reach that handler - hence capture phase on this element,
      // which runs before cart.js's document-level listener.

      this.addEventListener('click', function (event) {
        if (!event.target.closest('[data-atc-button]')) return;

        var stage = _this30.currentStage();

        if (stage === 'steps') return;
        event.preventDefault();
        event.stopPropagation();
        if (stage === 'variants') _this30.confirmVariantStage();

        _this30.popStage();
      }, true); // The dialog's close button lives in the shell (snippets/bundle-modal-dialog.liquid), outside this
      // element, and src/js/bundle-modal.js already binds it to close the modal. On stages 2 and 3 it has to
      // act as "back" instead - the design shows the same X in the same place on every stage and no separate
      // back affordance, and without this those stages are dead ends. Bound in capture phase on the DIALOG
      // rather than the button: listeners on the button itself would fire in registration order (bundle-modal
      // .js registered first), whereas an ancestor's capture listener always runs before the target's.

      var dialog = this.closest('dialog');

      if (dialog) {
        this.dialogEl = dialog;

        this.dialogCaptureHandler = function (event) {
          if (!event.target.closest('[data-bundle-modal-dialog-close]')) return;
          if (_this30.currentStage() === 'steps') return;
          event.preventDefault();
          event.stopPropagation();

          _this30.popStage();
        };

        dialog.addEventListener('click', this.dialogCaptureHandler, true);
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      // The dialog outlives this element (bundle-modal.js replaces the dialog's innerHTML on every open), so
      // the capture listener above has to come off with it or handlers stack up per open.
      if (this.dialogEl && this.dialogCaptureHandler) {
        this.dialogEl.removeEventListener('click', this.dialogCaptureHandler, true);
      } // Same reason: the watcher listens on `document`, which also outlives this element, so a discarded
      // builder would otherwise keep answering 'cart:updated' for a CTA that is no longer in the page. One
      // stale listener per dialog open before this.


      if (this.limitWatcher) this.limitWatcher.destroy();
    }
    /* ------------------------------------------------------------------ stage 1 rendering */

  }, {
    key: "renderAllStepLines",
    value: function renderAllStepLines() {
      var _this31 = this;

      this.steps.forEach(function (step) {
        return _this31.renderStepLines(step);
      });
    } // One line per selected product - a step with max > 1 shows several (the design only illustrates the
    // single-pick case; stacking the same line is the natural extension, flagged 2026-09-01). With nothing
    // picked yet the step renders its unselected state instead - see buildEmptyStepLine().

  }, {
    key: "renderStepLines",
    value: function renderStepLines(step) {
      var _this32 = this;

      if (!step.linesEl) return;
      var picks = this.getPicks(step.id);
      step.linesEl.replaceChildren();

      if (!picks.length) {
        step.linesEl.appendChild(this.buildEmptyStepLine(step)); // No attachChangeButton here — the placeholder is the tap target.

        return;
      } // The step label goes on the FIRST line only - it names the step, not each pick, so a multi-pick step
      // shows it once with the remaining lines aligning under it.


      picks.forEach(function (pick, index) {
        var product = _this32.productsById.get(pick.productId);

        var title = product && product.title || '';
        step.linesEl.appendChild(_this32.buildStepLine(pick.productId, title, pick, index === 0 ? step.label : '', step.image));
      });
      this.attachChangeButton(step);
    } // The unselected state. Two variants:
    //   Shade  (single product, multiple variants): row is single-column; prompt styled as a shade-row
    //           dropdown (border, chevron) so it matches the picker on stage 2 product rows.
    //   Product (all other steps): row keeps the standard 72px / 1fr grid; a grey placeholder fills the
    //           image slot so the layout doesn't collapse, and the prompt is a plain text link.
    // The unselected state. Two variants:
    //   Shade  (single product, multiple variants): product is pre-determined — show its image and title,
    //           then the shade-row prompt so only the shade needs picking.
    //   Product (all other steps): grey placeholder fills the image slot; prompt reads "Select a product".
    // Both use the standard 72px / 1fr grid and the same shade-row border/chevron style for the prompt.
    // No CHANGE button appears — attachChangeButton() is not called while picks.length === 0.

  }, {
    key: "buildEmptyStepLine",
    value: function buildEmptyStepLine(step) {
      var _this33 = this;

      var singleMultiVariant = step.products.length === 1 && parseInt(step.products[0].variant_count || '1', 10) > 1;
      var row = document.createElement('div');
      row.className = singleMultiVariant ? 'bundle-modal-step-line is-empty is-empty--shade' : 'bundle-modal-step-line is-empty is-empty--product'; // Shade steps look up the one product so its image and title can be shown.

      var entry = singleMultiVariant ? step.products[0] : null;
      var product = entry ? this.productsById.get(entry.product_id) : null; // With no product image to show, the step's own group image from bundle_config stands in for the empty
      // grey square - the same stand-in the standalone builder uses for its own unselected steps. Where the
      // group has none, a product step falls back to the shop-level bundle.fallback_thumbnail
      // (data-fallback-image, see templates/product.bundle-modal.liquid), then the plain placeholder.

      var fallbackImage = step.image || (product ? '' : this.dataset.fallbackImage);
      var mediaImage = product && product.featuredImage && product.featuredImage.url || fallbackImage;
      var media = document.createElement('div');
      media.className = 'bundle-modal-step-line-media' + (mediaImage ? '' : ' bundle-modal-step-line-media--placeholder');

      if (mediaImage) {
        var img = document.createElement('img');
        img.src = mediaImage;
        img.alt = product && product.title || '';
        img.style.cssText = 'width:100%;height:100%;object-fit:cover';
        media.appendChild(img);
      }

      row.appendChild(media);
      var body = document.createElement('div');
      body.className = 'bundle-modal-step-line-body flex flex-col gap-1 min-w-0';

      if (step.label) {
        var labelEl = document.createElement('span');
        labelEl.className = 'bundle-modal-step-label';
        labelEl.textContent = step.label;
        body.appendChild(labelEl);
      } // Shade steps: show the product title above the shade prompt.


      if (product) {
        var titleEl = document.createElement('span');
        titleEl.className = 'bundle-modal-step-title';
        titleEl.textContent = product.title;
        body.appendChild(titleEl);
      } // Both prompts: shade-row style (border, uppercase, chevron).


      var prompt = document.createElement('button');
      prompt.type = 'button';
      prompt.className = 'bundle-modal-select-prompt bundle-modal-shade-row';
      prompt.addEventListener('click', function () {
        return _this33.openProductStage(step);
      }); // Shade prompt: empty swatch circle placeholder mirrors the filled dot shown once a shade is picked.

      if (singleMultiVariant) {
        var dot = document.createElement('span');
        dot.className = 'bundle-step-swatch-dot shrink-0 rounded-full';
        prompt.appendChild(dot);
      }

      var labelSpan = document.createElement('span');
      labelSpan.className = 'flex-1 text-left';
      labelSpan.textContent = singleMultiVariant ? this.dataset.labelSelectShade || 'Select a shade' : this.dataset.labelSelectProduct || 'Select a product';
      prompt.appendChild(labelSpan);
      var chevron = document.createElement('span');
      chevron.className = 'bundle-modal-shade-chevron';
      prompt.appendChild(chevron);
      body.appendChild(prompt);
      row.appendChild(body);
      return row;
    } // Moves the step's Liquid-rendered CHANGE button into the last line's CONTENT column, under the swatch,
    // rather than full width across the card. Inside the content div specifically (not as a third grid row of
    // its own) so the button counts towards the column's height and the image centres against the whole
    // block - confirmed 2026-09-01. appendChild() on an already-present element relocates rather than clones
    // it, the same trick sinkSoldOutOptions() uses, which keeps the button's label in Liquid and translatable.
    // Last line, so a multi-pick step shows one button below all its picks.

  }, {
    key: "attachChangeButton",
    value: function attachChangeButton(step) {
      if (!step.changeBtn) return;
      var lastBody = step.linesEl.querySelector('.bundle-modal-step-line:last-child .bundle-modal-step-line-body');
      if (!lastBody) return; // Button is hidden by CSS until a pick exists; reveal it here when moving it into the line.

      step.changeBtn.style.display = 'block';
      lastBody.appendChild(step.changeBtn);
    } // Confirmed 2026-09-01 against the design: the line below the title is the chosen shade's swatch + name
    // where there is one, and otherwise the product's short description - never both.
    // stepImage is the group's own fallback image, used only where the chosen product has no image of its own.

  }, {
    key: "buildStepLine",
    value: function buildStepLine(productId, title, pick, label, stepImage) {
      var product = this.productsById.get(productId);
      var row = document.createElement('div');
      row.className = "bundle-modal-step-line".concat(pick && pick.unavailable ? ' is-unavailable' : '');
      var media = document.createElement('div');
      media.className = 'bundle-modal-step-line-media';
      var featuredImage = product && product.featuredImage;

      if (featuredImage || stepImage) {
        var img = document.createElement('img');
        img.src = featuredImage ? featuredImage.url : stepImage;
        img.alt = featuredImage ? featuredImage.altText || title || '' : '';
        img.loading = 'lazy';
        img.className = featuredImage ? 'w-full h-full object-contain' : 'w-full h-full object-cover';
        media.appendChild(img);
      }

      var body = document.createElement('div');
      body.className = 'bundle-modal-step-line-body flex flex-col gap-1 min-w-0';

      if (label) {
        var labelEl = document.createElement('span');
        labelEl.className = 'bundle-modal-step-label font-bold';
        labelEl.textContent = label;
        body.appendChild(labelEl);
      }

      var titleEl = document.createElement('span');
      titleEl.className = 'bundle-modal-step-title';
      titleEl.textContent = title;
      body.appendChild(titleEl); // Nothing sellable left in this step (applyStepAvailability() seeds the pick that lands here with
      // unavailable: true). Until now the row only dimmed and its CHANGE button went dead, leaving the
      // bundle-level message to carry the whole explanation - most obviously wrong for a single-product
      // step, where the shopper has no alternative to switch to and nothing named the problem. Stated on
      // the step itself now, matching the per-step line the PDP builder shows (see applyStepAvailability()
      // and product-bundle-2026-step.liquid). Replaces the swatch/description line rather than joining it:
      // neither says anything useful about a product that can't be bought.

      if (pick && pick.unavailable) {
        var unavailableEl = document.createElement('p');
        unavailableEl.className = 'bundle-modal-step-unavailable text-sm';
        unavailableEl.textContent = this.dataset.labelOutOfStock || '';
        body.appendChild(unavailableEl);
        row.append(media, body);
        return row;
      }

      if (pick && pick.shadeLabel) {
        var swatch = document.createElement('span');
        swatch.className = 'bundle-step-swatch flex items-center gap-1.5 text-sm';

        if (pick.shadeSwatch) {
          var dot = document.createElement('span');
          dot.className = 'bundle-step-swatch-dot shrink-0 rounded-full';
          dot.style.backgroundImage = "url(".concat(pick.shadeSwatch, ")");
          swatch.appendChild(dot);
        }

        var _label = document.createElement('span');

        _label.textContent = pick.shadeLabel;
        swatch.appendChild(_label);
        body.appendChild(swatch);
      } else {
        var description = this.shortDescriptionFor(productId);

        if (description) {
          var p = document.createElement('p');
          p.className = 'text-sm text-charcoal-70';
          p.textContent = description;
          body.appendChild(p);
        }
      }

      row.append(media, body);
      return row;
    }
    /* ------------------------------------------------------------------ stage 2: product list */

  }, {
    key: "openProductStage",
    value: function openProductStage(step) {
      // A step with exactly one product and multiple variants has no product list to show — the only
      // meaningful choice is the shade. Skip stage 2 and go straight to shade selection (stage 3).
      if (step.products.length === 1 && parseInt(step.products[0].variant_count || '1', 10) > 1) {
        this.openVariantStage(step, step.products[0]);
        return;
      }

      this.activeStep = step;
      this.renderProductStage();
      this.pushStage('products');
    }
  }, {
    key: "refreshOpenProductStage",
    value: function refreshOpenProductStage() {
      if (this.currentStage() === 'products' && this.activeStep) this.renderProductStage();
    }
  }, {
    key: "renderProductStage",
    value: function renderProductStage() {
      var _this34 = this;

      var step = this.activeStep;
      var stageEl = this.stageEls.get('products');
      if (!step || !stageEl) return;
      var titleEl = stageEl.querySelector('[data-bundle-stage-title]');
      var promptEl = stageEl.querySelector('[data-bundle-stage-prompt]');
      var listEl = stageEl.querySelector('[data-bundle-product-list]');
      if (titleEl) titleEl.textContent = step.label;

      if (promptEl) {
        promptEl.textContent = step.max === 1 ? this.dataset.labelPickOne || '' : (this.dataset.labelPickUpTo || '').replace('__COUNT__', String(step.max));
      }

      if (!listEl) return; // Sold-out products sink to the base of the list, matching the standalone builder's own
      // sinkSoldOutOptions() rather than leaving them wherever the metafield ordered them.

      var entries = step.products.slice().sort(function (a, b) {
        var aOut = _this34.productAvailable(a.product_id) ? 0 : 1;
        var bOut = _this34.productAvailable(b.product_id) ? 0 : 1;
        return aOut - bOut;
      });
      listEl.replaceChildren.apply(listEl, _toConsumableArray(entries.map(function (entry) {
        return _this34.buildProductRow(step, entry);
      })));
    }
  }, {
    key: "buildProductRow",
    value: function buildProductRow(step, entry) {
      var _this35 = this;

      var available = this.productAvailable(entry.product_id);
      var picked = this.isPicked(step.id, entry.product_id);
      var product = this.productsById.get(entry.product_id);
      var pick = this.getPicks(step.id).find(function (candidate) {
        return candidate.productId === entry.product_id;
      });
      var row = document.createElement('div');
      row.className = "bundle-modal-product-row".concat(available ? '' : ' is-unavailable').concat(picked ? ' is-picked' : '');
      var media = document.createElement('div');
      media.className = 'bundle-modal-product-media';

      if (product && product.featuredImage) {
        var img = document.createElement('img');
        img.src = product.featuredImage.url;
        img.alt = product.featuredImage.altText || entry.title || '';
        img.loading = 'lazy';
        img.className = 'w-full h-full object-contain';
        media.appendChild(img);
      }

      var body = document.createElement('div');
      body.className = 'flex flex-col gap-1.5 min-w-0';
      var titleEl = document.createElement('span');
      titleEl.className = 'font-medium';
      titleEl.textContent = product && product.title || entry.title || '';
      body.appendChild(titleEl);
      var description = this.shortDescriptionFor(entry.product_id);

      if (description) {
        var p = document.createElement('p');
        p.className = 'text-sm text-charcoal-70';
        p.textContent = description;
        body.appendChild(p);
      } // A sold-out SINGLE-variant product had nothing but the greyed row and a disabled checkbox to say so -
      // the out-of-stock wording lived only on the shade row below, which such a product never renders. Said
      // here instead for that case, so every sold-out row in the list reads the same way.


      var entryVariantCount = parseInt(entry.variant_count || '1', 10);

      if (!available && entryVariantCount <= 1) {
        var unavailableEl = document.createElement('p');
        unavailableEl.className = 'bundle-modal-step-unavailable text-sm';
        unavailableEl.textContent = this.dataset.labelOutOfStock || '';
        body.appendChild(unavailableEl);
      } // A multi-variant product gets the shade row from the design - a dropdown-looking button that opens
      // stage 3 rather than a native <select>. It reads the chosen shade once there is one, and doubles as
      // where the out-of-stock state is surfaced.


      var variantCount = parseInt(entry.variant_count || '1', 10);

      if (variantCount > 1) {
        var hasShade = Boolean(pick && pick.shadeLabel);
        var shadeBtn = document.createElement('button');
        shadeBtn.type = 'button'; // is-selected lifts the row out of its muted placeholder colour - confirmed 2026-09-01 a chosen shade
        // should read as chosen rather than staying as grey as the "select a shade" prompt.

        shadeBtn.className = "bundle-modal-shade-row".concat(hasShade ? ' is-selected' : '');
        shadeBtn.disabled = !available;
        var dot = document.createElement('span');
        dot.className = 'bundle-step-swatch-dot shrink-0 rounded-full';
        if (pick && pick.shadeSwatch) dot.style.backgroundImage = "url(".concat(pick.shadeSwatch, ")");
        var label = document.createElement('span');
        label.className = 'grow text-left truncate';
        label.textContent = available ? hasShade && pick.shadeLabel || this.dataset.labelSelectShade || '' : this.dataset.labelOutOfStock || '';
        var chevron = document.createElement('span');
        chevron.className = 'bundle-modal-shade-chevron shrink-0';
        shadeBtn.append(dot, label, chevron);
        if (available) shadeBtn.addEventListener('click', function () {
          return _this35.openVariantStage(step, entry);
        });
        body.appendChild(shadeBtn);
      } // Styled as a checkbox per the design even where the step is single-pick, including a step whose
      // candidate list happens to have only one product - togglePick() handles the radio-like replace
      // behaviour for max: 1, so the control reads consistently across all three cases.


      var checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.className = 'bundle-modal-product-checkbox';
      checkbox.checked = picked;
      checkbox.disabled = !available;
      checkbox.setAttribute('aria-label', product && product.title || entry.title || ''); // Driven off `picked` (the selection state this row was built from) rather than checkbox.checked, so the
      // same handler serves both the checkbox's native change and a click anywhere on the row - the row-click
      // path never flips the checkbox itself. renderProductStage() below rebuilds every row from state, so the
      // checkbox only needs resetting on the early-return paths that deliberately don't change anything.

      var handleToggle = function handleToggle() {
        if (!available) return; // A multi-variant product can't be committed without a shade - send the shopper to stage 3 instead of
        // silently pinning them to the product's first variant (same reasoning as the standalone builder's
        // openSelectShadeDialog()).

        if (!picked && variantCount > 1 && !(pick && pick.shadeLabel)) {
          checkbox.checked = picked;

          _this35.openVariantStage(step, entry);

          return;
        }

        var changed = _this35.togglePick(step, entry);

        if (!changed) {
          // Step already at its max and multi-pick - the tap is refused rather than evicting an earlier
          // choice the shopper didn't ask to lose.
          checkbox.checked = picked;
          return;
        }

        _this35.renderProductStage();

        _this35.renderAllStepLines();

        _this35.updateState();
      };

      checkbox.addEventListener('change', handleToggle); // Confirmed 2026-09-02: the whole row is the control, matching how the shade rows on stage 3 behave -
      // having to hit the checkbox itself was inconsistent with that. Clicks on the checkbox are skipped here
      // because its own change event already handles them (the click bubbles up to this listener too, and
      // would otherwise toggle twice); clicks on the shade button are skipped because that opens stage 3.

      row.addEventListener('click', function (event) {
        if (event.target.closest('input, button')) return;
        handleToggle();
      });
      row.append(media, body, checkbox);
      return row;
    }
    /* ------------------------------------------------------------------ stage 3: shade list */
    // Fetches the same ?view=variant-selector-2026 fragment the standalone builder's dialog uses (see
    // snippets/product-variants-2026.liquid), but renders it into this stage rather than a second dialog
    // stacked on top of the first - the whole point of SBA-982's staged model.

  }, {
    key: "openVariantStage",
    value: function () {
      var _openVariantStage = _asyncToGenerator( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee9(step, entry) {
        var _this36 = this;

        var product, stageEl, listEl, pick, url, rendered, titleEl, mediaEl, img;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                product = this.productsById.get(entry.product_id);

                if (!(!product || !product.handle)) {
                  _context9.next = 3;
                  break;
                }

                return _context9.abrupt("return");

              case 3:
                stageEl = this.stageEls.get('variants');
                listEl = stageEl && stageEl.querySelector('[data-bundle-variant-list]');

                if (listEl) {
                  _context9.next = 7;
                  break;
                }

                return _context9.abrupt("return");

              case 7:
                pick = this.getPicks(step.id).find(function (candidate) {
                  return candidate.productId === entry.product_id;
                }); // variantGid is stored as bare numeric (v3 metafield); toNumericId() is a safe no-op that also
                // handles any legacy GID-shaped value that may have survived in sessionStorage.

                url = (0,_bundle_fragments_js__WEBPACK_IMPORTED_MODULE_8__.productViewUrl)(product.handle, 'variant-selector-2026', {
                  variant: pick && pick.variantGid ? (0,_bundle_ids_js__WEBPACK_IMPORTED_MODULE_1__.toNumericId)(pick.variantGid) : ''
                }); // Fails soft, same as the standalone builder - stays on the current stage rather than pushing an
                // empty one the shopper then has to back out of.

                _context9.next = 11;
                return (0,_bundle_fragments_js__WEBPACK_IMPORTED_MODULE_8__.renderFragmentInto)(listEl, url, {
                  label: 'shade selector'
                });

              case 11:
                rendered = _context9.sent;

                if (rendered) {
                  _context9.next = 14;
                  break;
                }

                return _context9.abrupt("return");

              case 14:
                titleEl = stageEl.querySelector('[data-bundle-variant-stage-title]');
                mediaEl = stageEl.querySelector('[data-bundle-variant-stage-media]');
                if (titleEl) titleEl.textContent = product.title || entry.title || '';

                if (mediaEl) {
                  mediaEl.replaceChildren();

                  if (product.featuredImage) {
                    img = document.createElement('img');
                    img.src = product.featuredImage.url;
                    img.alt = product.featuredImage.altText || product.title || '';
                    img.className = 'w-full';
                    mediaEl.appendChild(img);
                  }
                } // REVISED 2026-09-02: picking a shade commits it and returns to stage 2 immediately, rather than only
                // highlighting it and waiting for the footer CTA - one tap instead of two, and the same behaviour as the
                // standalone builder's selectShade(). The footer CTA still works on this stage as a plain "done": once a
                // click has committed, pendingVariant is null and confirmVariantStage() no-ops, so it just pops back.


                this.pendingVariant = pick && pick.shadeLabel ? _objectSpread({
                  step: step,
                  entry: entry
                }, pick) : {
                  step: step,
                  entry: entry
                }; // Sold-out variants stay visible (the shade range still reads complete) but aren't selectable. Fourth
                // and last copy of that rule - see bindVariantRows() in ./bundle/drawer.js.

                (0,_bundle_drawer_js__WEBPACK_IMPORTED_MODULE_9__.bindVariantRows)(listEl, function (event) {
                  _this36.stageVariant(step, entry, event.currentTarget);

                  _this36.confirmVariantStage();

                  _this36.popStage();
                });
                this.pushStage('variants');

              case 21:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function openVariantStage(_x5, _x6) {
        return _openVariantStage.apply(this, arguments);
      }

      return openVariantStage;
    }() // Records the clicked shade, immediately before confirmVariantStage() commits it (see openVariantStage()).
    // Price comes off the fragment's own [data-variants-json] - the real Liquid-rendered variant data - rather
    // than a separate request, same as the base's selectShade().

  }, {
    key: "stageVariant",
    value: function stageVariant(step, entry, label) {
      var numericVariantId = label.dataset.variantId;
      var swatchImg = label.querySelector('img');
      var price;
      var stageEl = this.stageEls.get('variants');
      var variantsJsonEl = stageEl && stageEl.querySelector('[data-variants-json]');

      if (variantsJsonEl) {
        try {
          var variants = JSON.parse(variantsJsonEl.textContent);
          var variant = variants.find(function (candidate) {
            return String(candidate.id) === String(numericVariantId);
          });
          if (variant && variant.price !== undefined) price = variant.price;
        } catch (error) {// Fail soft - the price falls back to whatever resolveProductData() resolved for this variant (see
          // priceFor()), so the total still catches up.
        }
      }

      this.pendingVariant = {
        step: step,
        entry: entry,
        variantGid: numericVariantId,
        price: price,
        shadeLabel: label.dataset.labelValue || '',
        shadeSwatch: swatchImg ? swatchImg.src : ''
      };
    } // Commits the clicked shade. Called from the row click itself (see openVariantStage()), and still from the
    // footer CTA on stage 3 for the case where nothing was clicked - where it no-ops. Committing the shade also
    // selects the product it belongs to: the design offers "select a shade" on an unchecked row, so a shade
    // pick is the shopper choosing that product.

  }, {
    key: "confirmVariantStage",
    value: function confirmVariantStage() {
      var pending = this.pendingVariant;
      if (!pending || !pending.variantGid) return;
      this.togglePick(pending.step, pending.entry, {
        variantGid: pending.variantGid,
        price: pending.price,
        shadeLabel: pending.shadeLabel,
        shadeSwatch: pending.shadeSwatch
      });
      this.pendingVariant = null;
      this.renderAllStepLines();
      this.updateState();
    }
  }]);

  return BundleModalBuilder;
}(BundleBuilder);

customElements.define('bundle-modal-builder', BundleModalBuilder);
})();

/******/ })()
;